/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	var Pikaday = __webpack_require__(2);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	__webpack_require__(8)
	__webpack_require__(9)
	var modernizr = __webpack_require__(10)
	// require('../../../node_modules/atp-ng/dist/ng-atp');
	
	__webpack_require__(11);
	__webpack_require__(12);
	__webpack_require__(13)
	__webpack_require__(14);
	__webpack_require__(15);
	__webpack_require__(16);
	__webpack_require__(17);
	__webpack_require__(18);
	__webpack_require__(19);
	__webpack_require__(20);
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(23);
	__webpack_require__(24);
	__webpack_require__(25);
	__webpack_require__(26);
	__webpack_require__(27);
	__webpack_require__(28);
	__webpack_require__(29);
	// require('./sendEmail_ctrl');
	__webpack_require__(30);
	__webpack_require__(31);
	__webpack_require__(32);
	
	
	var quote_hash = 0;// hate globals, but $scope updates suxx
	Storage.prototype.setObject = function(key, value) { this.setItem(key, JSON.stringify(value)) };
	Storage.prototype.getObject = function(key) { 
	  var value = this.getItem(key);  
	  try {
	    return JSON.parse(value); 
	  } catch (ex) { return null; }
	}
	
	Array.prototype.find_by_prop = function(prop_name, prop_value) {
	  for (ind in this) {
	    if (!this.hasOwnProperty(ind)) continue;
	    if (this[ind][prop_name]==prop_value) return this[ind];
	  };
	  return null;
	}
	window.jsonlddata = []


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Pikaday
	 *
	 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
	 */
	
	(function (root, factory)
	{
	    'use strict';
	
	    var moment;
	    if (true) {
	        // CommonJS module
	        // Load moment.js as an optional dependency
	        try { moment = __webpack_require__(3); } catch (e) {}
	        module.exports = factory(moment);
	    } else if (typeof define === 'function' && define.amd) {
	        // AMD. Register as an anonymous module.
	        define(function (req)
	        {
	            // Load moment.js as an optional dependency
	            var id = 'moment';
	            moment = req.defined && req.defined(id) ? req(id) : undefined;
	            return factory(moment);
	        });
	    } else {
	        root.Pikaday = factory(root.moment);
	    }
	}(this, function (moment)
	{
	    'use strict';
	
	    /**
	     * feature detection and helper functions
	     */
	    var hasMoment = typeof moment === 'function',
	
	    hasEventListeners = !!window.addEventListener,
	
	    document = window.document,
	
	    sto = window.setTimeout,
	
	    addEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.addEventListener(e, callback, !!capture);
	        } else {
	            el.attachEvent('on' + e, callback);
	        }
	    },
	
	    removeEvent = function(el, e, callback, capture)
	    {
	        if (hasEventListeners) {
	            el.removeEventListener(e, callback, !!capture);
	        } else {
	            el.detachEvent('on' + e, callback);
	        }
	    },
	
	    fireEvent = function(el, eventName, data)
	    {
	        var ev;
	
	        if (document.createEvent) {
	            ev = document.createEvent('HTMLEvents');
	            ev.initEvent(eventName, true, false);
	            ev = extend(ev, data);
	            el.dispatchEvent(ev);
	        } else if (document.createEventObject) {
	            ev = document.createEventObject();
	            ev = extend(ev, data);
	            el.fireEvent('on' + eventName, ev);
	        }
	    },
	
	    trim = function(str)
	    {
	        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
	    },
	
	    hasClass = function(el, cn)
	    {
	        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
	    },
	
	    addClass = function(el, cn)
	    {
	        if (!hasClass(el, cn)) {
	            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
	        }
	    },
	
	    removeClass = function(el, cn)
	    {
	        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
	    },
	
	    isArray = function(obj)
	    {
	        return (/Array/).test(Object.prototype.toString.call(obj));
	    },
	
	    isDate = function(obj)
	    {
	        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
	    },
	
	    isLeapYear = function(year)
	    {
	        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    },
	
	    getDaysInMonth = function(year, month)
	    {
	        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	    },
	
	    setToStartOfDay = function(date)
	    {
	        if (isDate(date)) date.setHours(0,0,0,0);
	    },
	
	    compareDates = function(a,b)
	    {
	        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
	        return a.getTime() === b.getTime();
	    },
	
	    extend = function(to, from, overwrite)
	    {
	        var prop, hasProp;
	        for (prop in from) {
	            hasProp = to[prop] !== undefined;
	            if (hasProp && typeof from[prop] === 'object' && from[prop] != null && from[prop].nodeName === undefined) {
	                if (isDate(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = new Date(from[prop].getTime());
	                    }
	                }
	                else if (isArray(from[prop])) {
	                    if (overwrite) {
	                        to[prop] = from[prop].slice(0);
	                    }
	                } else {
	                    to[prop] = extend({}, from[prop], overwrite);
	                }
	            } else if (overwrite || !hasProp) {
	                to[prop] = from[prop];
	            }
	        }
	        return to;
	    },
	
	    adjustCalendar = function(calendar) {
	        if (calendar.month < 0) {
	            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
	            calendar.month += 12;
	        }
	        if (calendar.month > 11) {
	            calendar.year += Math.floor(Math.abs(calendar.month)/12);
	            calendar.month -= 12;
	        }
	        return calendar;
	    },
	
	    /**
	     * defaults and localisation
	     */
	    defaults = {
	        clas: '',
	        // bind the picker to a form field
	        field: null,
	
	        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
	        bound: undefined,
	
	        // position of the datepicker, relative to the field (default to bottom & left)
	        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
	        position: 'bottom left',
	
	        // automatically fit in the viewport even if it means repositioning from the position option
	        reposition: true,
	
	        // the default output format for `.toString()` and `field` value
	        format: 'YYYY-MM-DD',
	
	        // the initial date to view when first opened
	        defaultDate: null,
	
	        // make the `defaultDate` the initial selected value
	        setDefaultDate: false,
	
	        // first day of week (0: Sunday, 1: Monday etc)
	        firstDay: 0,
	
	        // the minimum/earliest date that can be selected
	        minDate: null,
	        // the maximum/latest date that can be selected
	        maxDate: null,
	
	        // number of years either side, or array of upper/lower range
	        yearRange: 10,
	
	        // show week numbers at head of row
	        showWeekNumber: false,
	
	        // used internally (don't config outside)
	        minYear: 0,
	        maxYear: 9999,
	        minMonth: undefined,
	        maxMonth: undefined,
	
	        isRTL: false,
	
	        // Additional text to append to the year in the calendar title
	        yearSuffix: '',
	
	        // Render the month after year in the calendar title
	        showMonthAfterYear: false,
	
	        // how many months are visible
	        numberOfMonths: 1,
	
	        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
	        // only used for the first display or when a selected date is not visible
	        mainCalendar: 'left',
	
	        // Specify a DOM element to render the calendar in
	        container: undefined,
	
	        // internationalization
	        i18n: {
	            previousMonth : 'Previous Month',
	            nextMonth     : 'Next Month',
	            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
	            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	            weekdaysShort : ['S','M','T','W','T','F','S']
	        },
	
	        // callback function
	        onSelect: null,
	        onOpen: null,
	        onClose: null,
	        onDraw: null,
	        onBeforeDraw: null
	    },
	
	
	    /**
	     * templating functions to abstract HTML rendering
	     */
	    renderDayName = function(opts, day, abbr)
	    {
	        day += opts.firstDay;
	        while (day >= 7) {
	            day -= 7;
	        }
	        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
	    },
	
	    renderDay = function(d, m, y, isSelected, isToday, isDisabled, isEmpty, isRangeStart, isRangeEnd, isInRange)
	    {
	        if (isEmpty) {
	            return '<td class="is-empty"></td>';
	        }
	        var arr = [];
	        if (isDisabled) {
	            arr.push('is-disabled');
	        }
	        if (isToday) {
	            arr.push('is-today');
	        }
	        if (isSelected) {
	            arr.push('is-selected');
	        }
	        if (isRangeStart) {
	          arr.push('range-start');
	        }
	        if (isRangeEnd) {
	          arr.push('range-end');
	        }
	        if (isInRange) {
	          arr.push('range');
	        }
	        return '<td data-day="' + d + '" class="' + arr.join(' ') + '">' +
	                 '<button class="pika-button pika-day" type="button" ' +
	                    'data-pika-year="' + y + '" data-pika-month="' + m + '" data-pika-day="' + d + '">' +
	                        d +
	                 '</button>' +
	               '</td>';
	    },
	
	    renderWeek = function (d, m, y) {
	        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
	        var onejan = new Date(y, 0, 1),
	            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
	        return '<td class="pika-week">' + weekNum + '</td>';
	    },
	
	    renderRow = function(days, isRTL)
	    {
	        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
	    },
	
	    renderBody = function(rows)
	    {
	        return '<tbody>' + rows.join('') + '</tbody>';
	    },
	
	    renderHead = function(opts)
	    {
	        var i, arr = [];
	        if (opts.showWeekNumber) {
	            arr.push('<th></th>');
	        }
	        for (i = 0; i < 7; i++) {
	            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
	        }
	        return '<thead>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</thead>';
	    },
	
	    renderTitle = function(instance, c, year, month, refYear)
	    {
	        var i, j, arr,
	            opts = instance._o,
	            isMinYear = year === opts.minYear,
	            isMaxYear = year === opts.maxYear,
	            html = '<div class="pika-title">',
	            monthHtml,
	            yearHtml,
	            prev = true,
	            next = true;
	
	        for (arr = [], i = 0; i < 12; i++) {
	            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
	                (i === month ? ' selected': '') +
	                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled' : '') + '>' +
	                opts.i18n.months[i] + '</option>');
	        }
	        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select-month">' + arr.join('') + '</select></div>';
	
	        if (isArray(opts.yearRange)) {
	            i = opts.yearRange[0];
	            j = opts.yearRange[1] + 1;
	        } else {
	            i = year - opts.yearRange;
	            j = 1 + year + opts.yearRange;
	        }
	
	        for (arr = []; i < j && i <= opts.maxYear; i++) {
	            if (i >= opts.minYear) {
	                arr.push('<option value="' + i + '"' + (i === year ? ' selected': '') + '>' + (i) + '</option>');
	            }
	        }
	        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select-year">' + arr.join('') + '</select></div>';
	
	        if (opts.showMonthAfterYear) {
	            html += yearHtml + monthHtml;
	        } else {
	            html += monthHtml + yearHtml;
	        }
	
	        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
	            prev = false;
	        }
	
	        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
	            next = false;
	        }
	
	        if (c === 0) {
	            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
	        }
	        if (c === (instance._o.numberOfMonths - 1) ) {
	            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
	        }
	
	        return html += '</div>';
	    },
	
	    renderTable = function(opts, data)
	    {
	        return '<table cellpadding="0" cellspacing="0" class="pika-table">' + renderHead(opts) + renderBody(data) + '</table>';
	    },
	
	
	    /**
	     * Pikaday constructor
	     */
	    Pikaday = function(options)
	    {
	        var self = this,
	            opts = self.config(options);
	
	        self._onMouseDown = function(e)
	        {
	            if (!self._v) {
	                return;
	            }
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	
	            if (!hasClass(target, 'is-disabled')) {
	                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty')) {
	                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
	                    if (opts.bound) {
	                        sto(function() {
	                            self.hide();
	                            if (opts.field) {
	                                opts.field.blur();
	                            }
	                        }, 100);
	                    }
	                    return;
	                }
	                else if (hasClass(target, 'pika-prev')) {
	                    self.prevMonth();
	                }
	                else if (hasClass(target, 'pika-next')) {
	                    self.nextMonth();
	                }
	            }
	            if (!hasClass(target, 'pika-select')) {
	                if (e.preventDefault) {
	                    e.preventDefault();
	                } else {
	                    e.returnValue = false;
	                    return false;
	                }
	            } else {
	                self._c = true;
	            }
	        };
	
	        self._onChange = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement;
	            if (!target) {
	                return;
	            }
	            if (hasClass(target, 'pika-select-month')) {
	                self.gotoMonth(target.value);
	            }
	            else if (hasClass(target, 'pika-select-year')) {
	                self.gotoYear(target.value);
	            }
	        };
	
	        self._onInputChange = function(e)
	        {
	            var date;
	
	            if (e.firedBy === self) {
	                return;
	            }
	            if (hasMoment) {
	                date = moment(opts.field.value, opts.format);
	                date = (date && date.isValid()) ? date.toDate() : null;
	            }
	            else {
	                date = new Date(Date.parse(opts.field.value));
	            }
	            self.setDate(isDate(date) ? date : null);
	            if (!self._v) {
	                self.show();
	            }
	        };
	
	        self._onInputFocus = function()
	        {
	            self.show();
	        };
	
	        self._onInputClick = function()
	        {
	            self.show();
	        };
	
	        self._onInputBlur = function()
	        {
	            if (!self._c) {
	                self._b = sto(function() {
	                    self.hide();
	                }, 50);
	            }
	            self._c = false;
	        };
	
	        self._onClick = function(e)
	        {
	            e = e || window.event;
	            var target = e.target || e.srcElement,
	                pEl = target;
	            if (!target) {
	                return;
	            }
	            if (!hasEventListeners && hasClass(target, 'pika-select')) {
	                if (!target.onchange) {
	                    target.setAttribute('onchange', 'return;');
	                    addEvent(target, 'change', self._onChange);
	                }
	            }
	            do {
	                if (hasClass(pEl, 'pika-single')) {
	                    return;
	                }
	            }
	            while ((pEl = pEl.parentNode));
	            if (self._v && target !== opts.trigger) {
	                self.hide();
	            }
	        };
	
	        self.el = document.createElement('div');
	        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '');
	
	        addEvent(self.el, 'mousedown', self._onMouseDown, true);
	        addEvent(self.el, 'change', self._onChange);
	
	        if (opts.field) {
	            if (opts.container) {
	                opts.container.appendChild(self.el);
	            } else if (opts.bound) {
	                document.body.appendChild(self.el);
	            } else {
	                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
	            }
	            addEvent(opts.field, 'change', self._onInputChange);
	
	            if (!opts.defaultDate) {
	                if (hasMoment && opts.field.value) {
	                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
	                } else {
	                    opts.defaultDate = new Date(Date.parse(opts.field.value));
	                }
	                opts.setDefaultDate = true;
	            }
	        }
	
	        var defDate = opts.defaultDate;
	
	        if (isDate(defDate)) {
	            if (opts.setDefaultDate) {
	                self.setDate(defDate, true);
	            } else {
	                self.gotoDate(defDate);
	            }
	        } else {
	            self.gotoDate(new Date());
	        }
	
	        if (opts.bound) {
	            this.hide();
	            self.el.className += ' is-bound';
	            addEvent(opts.trigger, 'click', self._onInputClick);
	            addEvent(opts.trigger, 'focus', self._onInputFocus);
	            addEvent(opts.trigger, 'blur', self._onInputBlur);
	        } else {
	            this.show();
	        }
	    };
	
	
	    /**
	     * public Pikaday API
	     */
	    Pikaday.prototype = {
	
	
	        /**
	         * configure functionality
	         */
	        config: function(options)
	        {
	            if (!this._o) {
	                this._o = extend({}, defaults, true);
	            }
	
	            var opts = extend(this._o, options, true);
	
	            opts.isRTL = !!opts.isRTL;
	
	            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;
	
	            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);
	
	            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;
	
	            var nom = parseInt(opts.numberOfMonths, 10) || 1;
	            opts.numberOfMonths = nom;
	
	            if (!isDate(opts.minDate)) {
	                opts.minDate = false;
	            }
	            if (!isDate(opts.maxDate)) {
	                opts.maxDate = false;
	            }
	            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
	                opts.maxDate = opts.minDate = false;
	            }
	            if (opts.minDate) {
	                setToStartOfDay(opts.minDate);
	                opts.minYear  = opts.minDate.getFullYear();
	                opts.minMonth = opts.minDate.getMonth();
	            }
	            if (opts.maxDate) {
	                setToStartOfDay(opts.maxDate);
	                opts.maxYear  = opts.maxDate.getFullYear();
	                opts.maxMonth = opts.maxDate.getMonth();
	            }
	
	            if (opts.rangeStart) {
	                setToStartOfDay(opts.rangeStart);
	            }
	            if (opts.rangeEnd) {
	                setToStartOfDay(opts.rangeEnd);
	            }
	
	
	            if (isArray(opts.yearRange)) {
	                var fallback = new Date().getFullYear() - 10;
	                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
	                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
	            } else {
	                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
	                if (opts.yearRange > 100) {
	                    opts.yearRange = 100;
	                }
	            }
	
	            return opts;
	        },
	
	        /**
	         * return a formatted string of the current selection (using Moment.js if available)
	         */
	        toString: function(format)
	        {
	            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
	        },
	
	        /**
	         * return a Moment.js object of the current selection (if available)
	         */
	        getMoment: function()
	        {
	            return hasMoment ? moment(this._d) : null;
	        },
	
	        /**
	         * set the current selection from a Moment.js object (if available)
	         */
	        setMoment: function(date, preventOnSelect)
	        {
	            if (hasMoment && moment.isMoment(date)) {
	                this.setDate(date.toDate(), preventOnSelect);
	            }
	        },
	
	        /**
	         * return a Date object of the current selection
	         */
	        getDate: function()
	        {
	            return isDate(this._d) ? new Date(this._d.getTime()) : null;
	        },
	
	        /**
	         * set the current selection
	         */
	        setDate: function(date, preventOnSelect)
	        {
	            if (!date) {
	                this._d = null;
	
	                if (this._o.field) {
	                    this._o.field.value = '';
	                    fireEvent(this._o.field, 'change', { firedBy: this });
	                }
	
	                return this.draw();
	            }
	            if (typeof date === 'string') {
	                date = new Date(Date.parse(date));
	            }
	            if (!isDate(date)) {
	                return;
	            }
	
	            var min = this._o.minDate,
	                max = this._o.maxDate;
	
	            if (isDate(min) && date < min) {
	                date = min;
	            } else if (isDate(max) && date > max) {
	                date = max;
	            }
	
	            this._d = new Date(date.getTime());
	            setToStartOfDay(this._d);
	            this.gotoDate(this._d);
	
	            if (this._o.field) {
	                this._o.field.value = this.toString();
	                fireEvent(this._o.field, 'change', { firedBy: this });
	            }
	            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
	                this._o.onSelect.call(this, this.getDate());
	            }
	        },
	
	        /**
	         * change view to a specific date
	         */
	        gotoDate: function(date)
	        {
	            var newCalendar = true;
	
	            if (!isDate(date)) {
	                return;
	            }
	
	            if (this.calendars) {
	                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
	                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
	                    visibleDate = date.getTime();
	                // get the end of the month
	                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
	                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
	                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
	            }
	
	            if (newCalendar) {
	                this.calendars = [{
	                    month: date.getMonth(),
	                    year: date.getFullYear()
	                }];
	                if (this._o.mainCalendar === 'right') {
	                    this.calendars[0].month += 1 - this._o.numberOfMonths;
	                }
	            }
	
	            this.adjustCalendars();
	        },
	
	        adjustCalendars: function() {
	            this.calendars[0] = adjustCalendar(this.calendars[0]);
	            for (var c = 1; c < this._o.numberOfMonths; c++) {
	                this.calendars[c] = adjustCalendar({
	                    month: this.calendars[0].month + c,
	                    year: this.calendars[0].year
	                });
	            }
	            this.draw();
	        },
	
	        gotoToday: function()
	        {
	            this.gotoDate(new Date());
	        },
	
	        /**
	         * change view to a specific month (zero-index, e.g. 0: January)
	         */
	        gotoMonth: function(month)
	        {
	            if (!isNaN(month)) {
	                this.calendars[0].month = parseInt(month, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        nextMonth: function()
	        {
	            this.calendars[0].month++;
	            this.adjustCalendars();
	        },
	
	        prevMonth: function()
	        {
	            this.calendars[0].month--;
	            this.adjustCalendars();
	        },
	
	        /**
	         * change view to a specific full year (e.g. "2012")
	         */
	        gotoYear: function(year)
	        {
	            if (!isNaN(year)) {
	                this.calendars[0].year = parseInt(year, 10);
	                this.adjustCalendars();
	            }
	        },
	
	        /**
	         * change the minDate
	         */
	        setMinDate: function(value)
	        {
	            this._o.minDate = value;
	        },
	
	        /**
	         * change the maxDate
	         */
	        setMaxDate: function(value)
	        {
	            this._o.maxDate = value;
	        },
	
	        /**
	         * change the RangeStart
	         */
	        setRangeStart: function(value)
	        {
	            if (typeof value=='string') value=new Date(value);
	            setToStartOfDay(value);
	            this._o.rangeStart = value;
	        },
	        /**
	         * change the RangeEnd
	         */
	        setRangeEnd: function(value)
	        {
	            if (typeof value=='string') value=new Date(value);
	            setToStartOfDay(value);
	            this._o.rangeEnd = value;
	        },
	
	        getRangeStart:function(){
	            return this._o.rangeStart;
	        },
	        getRangeEnd:function(){
	            return this._o.rangeEnd;
	        },
	
	        /**
	         * refresh the HTML
	         */
	        draw: function(force)
	        {
	            if (!this._v && !force) {
	                return;
	            }
	            if (typeof this._o.onBeforeDraw === 'function') {
	                var self = this;
	                sto(function() {
	                    self._o.onBeforeDraw.call(self);
	                }, 0);
	            }
	            var opts = this._o,
	                minYear = opts.minYear,
	                maxYear = opts.maxYear,
	                minMonth = opts.minMonth,
	                maxMonth = opts.maxMonth,
	                html = '';
	
	            if (this._y <= minYear) {
	                this._y = minYear;
	                if (!isNaN(minMonth) && this._m < minMonth) {
	                    this._m = minMonth;
	                }
	            }
	            if (this._y >= maxYear) {
	                this._y = maxYear;
	                if (!isNaN(maxMonth) && this._m > maxMonth) {
	                    this._m = maxMonth;
	                }
	            }
	            html +='<button class="close">back</button> ';
	            for (var c = 0; c < opts.numberOfMonths; c++) {
	                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year) + this.render(this.calendars[c].year, this.calendars[c].month) + '</div>';
	            }
	
	            this.el.innerHTML = html;
	
	
	            if (opts.bound) {
	                if(opts.field.type !== 'hidden') {
	                    sto(function() {
	                        opts.trigger.focus();
	                    }, 1);
	                }
	            }
	
	            if (typeof this._o.onDraw === 'function') {
	                var self = this;
	                sto(function() {
	                    self._o.onDraw.call(self);
	                }, 0);
	            }
	        },
	
	        adjustPosition: function()
	        {
	            if (this._o.container) return;
	            var field = this._o.trigger, pEl = field,
	            width = this.el.offsetWidth, height = this.el.offsetHeight,
	            viewportWidth = window.innerWidth || document.documentElement.clientWidth,
	            viewportHeight = window.innerHeight || document.documentElement.clientHeight,
	            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop,
	            left, top, clientRect;
	
	            if (typeof field.getBoundingClientRect === 'function') {
	                clientRect = field.getBoundingClientRect();
	                left = clientRect.left + window.pageXOffset;
	                top = clientRect.bottom + window.pageYOffset;
	            } else {
	                left = pEl.offsetLeft;
	                top  = pEl.offsetTop + pEl.offsetHeight;
	                while((pEl = pEl.offsetParent)) {
	                    left += pEl.offsetLeft;
	                    top  += pEl.offsetTop;
	                }
	            }
	
	            // default position is bottom & left
	            if ((this._o.reposition && left + width > viewportWidth) ||
	                (
	                    this._o.position.indexOf('right') > -1 &&
	                    left - width + field.offsetWidth > 0
	                )
	            ) {
	                left = left - width + field.offsetWidth;
	            }
	            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
	                (
	                    this._o.position.indexOf('top') > -1 &&
	                    top - height - field.offsetHeight > 0
	                )
	            ) {
	                top = top - height - field.offsetHeight;
	            }
	
	            this.el.style.cssText = [
	                'position: absolute',
	                'left: ' + left + 'px',
	                'top: ' + top + 'px'
	            ].join(';');
	        },
	
	        /**
	         * render HTML for a particular month
	         */
	        render: function(year, month)
	        {
	            var opts   = this._o,
	                now    = new Date(),
	                days   = getDaysInMonth(year, month),
	                before = new Date(year, month, 1).getDay(),
	                data   = [],
	                row    = [];
	            setToStartOfDay(now);
	            if (opts.firstDay > 0) {
	                before -= opts.firstDay;
	                if (before < 0) {
	                    before += 7;
	                }
	            }
	            var cells = days + before,
	                after = cells;
	            while(after > 7) {
	                after -= 7;
	            }
	            cells += 7 - after;
	            for (var i = 0, r = 0; i < cells; i++)
	            {
	                var day = new Date(year, month, 1 + (i - before)),
	                    isDisabled = (opts.minDate && day < opts.minDate) || (opts.maxDate && day > opts.maxDate),
	                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
	                    isToday = compareDates(day, now),
	                    isRangeStart = isDate(this._o.rangeStart) ? compareDates(day, this._o.rangeStart) : false,
	                    isRangeEnd   = isDate(this._o.rangeEnd) ? compareDates(day, this._o.rangeEnd) : false,
	                    isInRange    = isDate(this._o.rangeStart) && isDate(this._o.rangeEnd) && day >= this._o.rangeStart && day <= this._o.rangeEnd,
	                    isEmpty = i < before || i >= (days + before);
	
	                row.push(renderDay(1 + (i - before), month, year, isSelected, isToday, isDisabled, isEmpty, isRangeStart, isRangeEnd, isInRange));
	
	                if (++r === 7) {
	                    if (opts.showWeekNumber) {
	                        row.unshift(renderWeek(i - before, month, year));
	                    }
	                    data.push(renderRow(row, opts.isRTL));
	                    row = [];
	                    r = 0;
	                }
	            }
	            return renderTable(opts, data);
	        },
	
	        isVisible: function()
	        {
	            return this._v;
	        },
	
	        show: function()
	        {
	            if (!this._v) {
	                removeClass(this.el, 'is-hidden');
	                this._v = true;
	                this.draw();
	                if (this._o.bound) {
	                    addEvent(document, 'click', this._onClick);
	                    this.adjustPosition();
	                }
	                if (typeof this._o.onOpen === 'function') {
	                    this._o.onOpen.call(this);
	                }
	            }
	        },
	
	        hide: function()
	        {
	            var v = this._v;
	            if (v !== false) {
	                if (this._o.bound) {
	                    removeEvent(document, 'click', this._onClick);
	                }
	                this.el.style.cssText = '';
	                addClass(this.el, 'is-hidden');
	                this._v = false;
	                if (v !== undefined && typeof this._o.onClose === 'function') {
	                    this._o.onClose.call(this);
	                }
	            }
	        },
	
	        /**
	         * GAME OVER
	         */
	        destroy: function()
	        {
	            this.hide();
	            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
	            removeEvent(this.el, 'change', this._onChange);
	            if (this._o.field) {
	                removeEvent(this._o.field, 'change', this._onInputChange);
	                if (this._o.bound) {
	                    removeEvent(this._o.trigger, 'click', this._onInputClick);
	                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
	                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
	                }
	            }
	            if (this.el.parentNode) {
	                this.el.parentNode.removeChild(this.el);
	            }
	        }
	
	    };
	
	    return Pikaday;
	
	}));


/***/ },
/* 3 */
/***/ function(module, exports) {

	if(typeof moment === 'undefined') {var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
	module.exports = moment;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery.scrollTo
	 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
	 * Licensed under MIT
	 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
	 * @projectDescription Lightweight, cross-browser and highly customizable animated scrolling with jQuery
	 * @author Ariel Flesler
	 * @version 2.1.2
	 */
	;(function(factory) {
		'use strict';
		if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			// CommonJS
			module.exports = factory(require('jquery'));
		} else {
			// Global
			factory(jQuery);
		}
	})(function($) {
		'use strict';
	
		var $scrollTo = $.scrollTo = function(target, duration, settings) {
			return $(window).scrollTo(target, duration, settings);
		};
	
		$scrollTo.defaults = {
			axis:'xy',
			duration: 0,
			limit:true
		};
	
		function isWin(elem) {
			return !elem.nodeName ||
				$.inArray(elem.nodeName.toLowerCase(), ['iframe','#document','html','body']) !== -1;
		}		
	
		$.fn.scrollTo = function(target, duration, settings) {
			if (typeof duration === 'object') {
				settings = duration;
				duration = 0;
			}
			if (typeof settings === 'function') {
				settings = { onAfter:settings };
			}
			if (target === 'max') {
				target = 9e9;
			}
	
			settings = $.extend({}, $scrollTo.defaults, settings);
			// Speed is still recognized for backwards compatibility
			duration = duration || settings.duration;
			// Make sure the settings are given right
			var queue = settings.queue && settings.axis.length > 1;
			if (queue) {
				// Let's keep the overall duration
				duration /= 2;
			}
			settings.offset = both(settings.offset);
			settings.over = both(settings.over);
	
			return this.each(function() {
				// Null target yields nothing, just like jQuery does
				if (target === null) return;
	
				var win = isWin(this),
					elem = win ? this.contentWindow || window : this,
					$elem = $(elem),
					targ = target, 
					attr = {},
					toff;
	
				switch (typeof targ) {
					// A number will pass the regex
					case 'number':
					case 'string':
						if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
							targ = both(targ);
							// We are done
							break;
						}
						// Relative/Absolute selector
						targ = win ? $(targ) : $(targ, elem);
						/* falls through */
					case 'object':
						if (targ.length === 0) return;
						// DOMElement / jQuery
						if (targ.is || targ.style) {
							// Get the real position of the target
							toff = (targ = $(targ)).offset();
						}
				}
	
				var offset = $.isFunction(settings.offset) && settings.offset(elem, targ) || settings.offset;
	
				$.each(settings.axis.split(''), function(i, axis) {
					var Pos	= axis === 'x' ? 'Left' : 'Top',
						pos = Pos.toLowerCase(),
						key = 'scroll' + Pos,
						prev = $elem[key](),
						max = $scrollTo.max(elem, axis);
	
					if (toff) {// jQuery / DOMElement
						attr[key] = toff[pos] + (win ? 0 : prev - $elem.offset()[pos]);
	
						// If it's a dom element, reduce the margin
						if (settings.margin) {
							attr[key] -= parseInt(targ.css('margin'+Pos), 10) || 0;
							attr[key] -= parseInt(targ.css('border'+Pos+'Width'), 10) || 0;
						}
	
						attr[key] += offset[pos] || 0;
	
						if (settings.over[pos]) {
							// Scroll to a fraction of its width/height
							attr[key] += targ[axis === 'x'?'width':'height']() * settings.over[pos];
						}
					} else {
						var val = targ[pos];
						// Handle percentage values
						attr[key] = val.slice && val.slice(-1) === '%' ?
							parseFloat(val) / 100 * max
							: val;
					}
	
					// Number or 'number'
					if (settings.limit && /^\d+$/.test(attr[key])) {
						// Check the limits
						attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);
					}
	
					// Don't waste time animating, if there's no need.
					if (!i && settings.axis.length > 1) {
						if (prev === attr[key]) {
							// No animation needed
							attr = {};
						} else if (queue) {
							// Intermediate animation
							animate(settings.onAfterFirst);
							// Don't animate this axis again in the next iteration.
							attr = {};
						}
					}
				});
	
				animate(settings.onAfter);
	
				function animate(callback) {
					var opts = $.extend({}, settings, {
						// The queue setting conflicts with animate()
						// Force it to always be true
						queue: true,
						duration: duration,
						complete: callback && function() {
							callback.call(elem, targ, settings);
						}
					});
					$elem.animate(attr, opts);
				}
			});
		};
	
		// Max scrolling position, works on quirks mode
		// It only fails (not too badly) on IE, quirks mode.
		$scrollTo.max = function(elem, axis) {
			var Dim = axis === 'x' ? 'Width' : 'Height',
				scroll = 'scroll'+Dim;
	
			if (!isWin(elem))
				return elem[scroll] - $(elem)[Dim.toLowerCase()]();
	
			var size = 'client' + Dim,
				doc = elem.ownerDocument || elem.document,
				html = doc.documentElement,
				body = doc.body;
	
			return Math.max(html[scroll], body[scroll]) - Math.min(html[size], body[size]);
		};
	
		function both(val) {
			return $.isFunction(val) || $.isPlainObject(val) ? val : { top:val, left:val };
		}
	
		// Add special hooks so that window scroll properties can be animated
		$.Tween.propHooks.scrollLeft = 
		$.Tween.propHooks.scrollTop = {
			get: function(t) {
				return $(t.elem)[t.prop]();
			},
			set: function(t) {
				var curr = this.get(t);
				// If interrupt is true and user scrolled, stop animating
				if (t.options.interrupt && t._last && t._last !== curr) {
					return $(t.elem).stop();
				}
				var next = Math.round(t.now);
				// Don't waste CPU
				// Browsers don't render floating point scroll
				if (curr !== next) {
					$(t.elem)[t.prop](next);
					t._last = this.get(t);
				}
			}
		};
	
		// AMD requirement
		return $scrollTo;
	});


/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = angular;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*! respimage - v1.4.2 - 2015-08-22
	 Licensed MIT */
	!function(a,b,c){"use strict";function d(a){return a.trim?a.trim():a.replace(/^\s+|\s+$/g,"")}function e(){var b;R=!1,U=a.devicePixelRatio,S={},T={},b=(U||1)*D.xQuant,D.uT||(D.maxX=Math.max(1.3,D.maxX),b=Math.min(b,D.maxX),v.DPR=b),V.width=Math.max(a.innerWidth||0,B.clientWidth),V.height=Math.max(a.innerHeight||0,B.clientHeight),V.vw=V.width/100,V.vh=V.height/100,V.em=v.getEmValue(),V.rem=V.em,o=D.lazyFactor/2,o=o*b+o,q=.4+.1*b,l=.5+.2*b,m=.5+.25*b,p=b+1.3,(n=V.width>V.height)||(o*=.9),I&&(o*=.9),u=[V.width,V.height,b].join("-")}function f(a,b,c){var d=b*Math.pow(a-.4,1.9);return n||(d/=1.3),a+=d,a>c}function g(a){var b,c=v.getSet(a),d=!1;"pending"!=c&&(d=u,c&&(b=v.setRes(c),d=v.applySetCandidate(b,a))),a[v.ns].evaled=d}function h(a,b){return a.res-b.res}function i(a,b,c){var d;return!c&&b&&(c=a[v.ns].sets,c=c&&c[c.length-1]),d=j(b,c),d&&(b=v.makeUrl(b),a[v.ns].curSrc=b,a[v.ns].curCan=d,d.res||_(d,d.set.sizes)),d}function j(a,b){var c,d,e;if(a&&b)for(e=v.parseSet(b),a=v.makeUrl(a),c=0;c<e.length;c++)if(a==v.makeUrl(e[c].url)){d=e[c];break}return d}function k(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[v.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}var l,m,n,o,p,q,r,s,t,u,v={},w=function(){},x=b.createElement("img"),y=x.getAttribute,z=x.setAttribute,A=x.removeAttribute,B=b.documentElement,C={},D={xQuant:1,lazyFactor:.4,maxX:2},E="data-pfsrc",F=E+"set",G="webkitBackfaceVisibility"in B.style,H=navigator.userAgent,I=/rident/.test(H)||/ecko/.test(H)&&H.match(/rv\:(\d+)/)&&RegExp.$1>35,J="currentSrc",K=/\s+\+?\d+(e\d+)?w/,L=/((?:\([^)]+\)(?:\s*and\s*|\s*or\s*|\s*not\s*)?)+)?\s*(.+)/,M=/^([\+eE\d\.]+)(w|x)$/,N=/\s*\d+h\s*/,O=a.respimgCFG,P=("https:"==location.protocol,"position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)"),Q="font-size:100%!important;",R=!0,S={},T={},U=a.devicePixelRatio,V={px:1,"in":96},W=b.createElement("a"),X=!1,Y=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},Z=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},$=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=Z(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")});return function(b,d){var e;if(!(b in S))if(S[b]=!1,d&&(e=b.match(a)))S[b]=e[1]*V[e[2]];else try{S[b]=new Function("e",c(b))(V)}catch(f){}return S[b]}}(),_=function(a,b){return a.w?(a.cWidth=v.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.x,a},ab=function(c){var d,e,f,g=c||{};if(g.elements&&1==g.elements.nodeType&&("IMG"==g.elements.nodeName.toUpperCase()?g.elements=[g.elements]:(g.context=g.elements,g.elements=null)),g.reparse&&(g.reevaluate=!0,a.console&&console.warn&&console.warn("reparse was renamed to reevaluate!")),d=g.elements||v.qsa(g.context||b,g.reevaluate||g.reselect?v.sel:v.selShort),f=d.length){for(v.setupRun(g),X=!0,e=0;f>e;e++)v.fillImg(d[e],g);v.teardownRun(g)}},bb=Z(function(a){var b=[1,"x"],c=d(a||"");return c&&(c=c.replace(N,""),b=c.match(M)?[1*RegExp.$1,RegExp.$2]:!1),b});if(J in x||(J="src"),C["image/jpeg"]=!0,C["image/gif"]=!0,C["image/png"]=!0,C["image/svg+xml"]=b.implementation.hasFeature("http://wwwindow.w3.org/TR/SVG11/feature#Image","1.1"),v.ns=("ri"+(new Date).getTime()).substr(0,9),v.supSrcset="srcset"in x,v.supSizes="sizes"in x,v.supPicture=!!a.HTMLPictureElement,v.supSrcset&&v.supPicture&&!v.supSizes&&!function(a){x.srcset="data:,a",a.src="data:,a",v.supSrcset=x.complete===a.complete,v.supPicture=v.supSrcset&&v.supPicture}(b.createElement("img")),v.selShort="picture>img,img[srcset]",v.sel=v.selShort,v.cfg=D,v.supSrcset&&(v.sel+=",img["+F+"]"),v.DPR=U||1,v.u=V,v.types=C,s=v.supSrcset&&!v.supSizes,v.setSize=w,v.makeUrl=Z(function(a){return W.href=a,W.href}),v.qsa=function(a,b){return a.querySelectorAll(b)},v.matchesMedia=function(){return v.matchesMedia=a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?function(a){return!a||matchMedia(a).matches}:v.mMQ,v.matchesMedia.apply(this,arguments)},v.mMQ=function(a){return a?$(a):!0},v.calcLength=function(a){var b=$(a,!0)||!1;return 0>b&&(b=!1),b},v.supportsType=function(a){return a?C[a]:!0},v.parseSize=Z(function(a){var b=(a||"").match(L);return{media:b&&b[1],length:b&&b[2]}}),v.parseSet=function(a){if(!a.cands){var b,c,d,e,f,g,h=a.srcset;for(a.cands=[];h;)h=h.replace(/^\s+/g,""),b=h.search(/\s/g),d=null,-1!=b?(c=h.slice(0,b),e=c.charAt(c.length-1),","!=e&&c||(c=c.replace(/,+$/,""),d=""),h=h.slice(b+1),null==d&&(f=h.indexOf(","),-1!=f?(d=h.slice(0,f),h=h.slice(f+1)):(d=h,h=""))):(c=h,h=""),c&&(d=bb(d))&&(g={url:c.replace(/^,+/,""),set:a},g[d[1]]=d[0],"x"==d[1]&&1==d[0]&&(a.has1x=!0),a.cands.push(g))}return a.cands},v.getEmValue=function(){var a;if(!r&&(a=b.body)){var c=b.createElement("div"),d=B.style.cssText,e=a.style.cssText;c.style.cssText=P,B.style.cssText=Q,a.style.cssText=Q,a.appendChild(c),r=c.offsetWidth,a.removeChild(c),r=parseFloat(r,10),B.style.cssText=d,a.style.cssText=e}return r||16},v.calcListLength=function(a){if(!(a in T)||D.uT){var b,c,e,f,g,h,i=d(a).split(/\s*,\s*/),j=!1;for(g=0,h=i.length;h>g&&(b=i[g],c=v.parseSize(b),e=c.length,f=c.media,!e||!v.matchesMedia(f)||(j=v.calcLength(e))===!1);g++);T[a]=j?j:V.width}return T[a]},v.setRes=function(a){var b;if(a){b=v.parseSet(a);for(var c=0,d=b.length;d>c;c++)_(b[c],a.sizes)}return b},v.setRes.res=_,v.applySetCandidate=function(a,b){if(a.length){var c,d,e,g,j,k,n,r,s,t,w,x,y,z=b[v.ns],A=u,B=o,C=q;if(r=z.curSrc||b[J],s=z.curCan||i(b,r,a[0].set),d=v.DPR,y=s&&s.res,!n&&r&&(x=I&&!b.complete&&s&&y-.2>d,x||s&&!(p>y)||(s&&d>y&&y>l&&(m>y&&(B*=.8,C+=.04*d),s.res+=B*Math.pow(y-C,2)),t=!z.pic||s&&s.set==a[0].set,s&&t&&s.res>=d&&(n=s))),!n)for(y&&(s.res=s.res-(s.res-y)/2),a.sort(h),k=a.length,n=a[k-1],e=0;k>e;e++)if(c=a[e],c.res>=d){g=e-1,n=a[g]&&(j=c.res-d)&&(x||r!=v.makeUrl(c.url))&&f(a[g].res,j,d)?a[g]:c;break}return y&&(s.res=y),n&&(w=v.makeUrl(n.url),z.curSrc=w,z.curCan=n,w!=r&&v.setSrc(b,n),v.setSize(b)),A}},v.setSrc=function(a,b){var c;a.src=b.url,G&&(c=a.style.zoom,a.style.zoom="0.999",a.style.zoom=c)},v.getSet=function(a){var b,c,d,e=!1,f=a[v.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&v.matchesMedia(c.media)&&(d=v.supportsType(c.type))){"pending"==d&&(c=d),e=c;break}return e},v.parseSets=function(a,b,d){var e,f,g,h,i="PICTURE"==b.nodeName.toUpperCase(),l=a[v.ns];(l.src===c||d.src)&&(l.src=y.call(a,"src"),l.src?z.call(a,E,l.src):A.call(a,E)),(l.srcset===c||!v.supSrcset||a.srcset||d.srcset)&&(e=y.call(a,"srcset"),l.srcset=e,h=!0),l.sets=[],i&&(l.pic=!0,k(b,l.sets)),l.srcset?(f={srcset:l.srcset,sizes:y.call(a,"sizes")},l.sets.push(f),g=(s||l.src)&&K.test(l.srcset||""),g||!l.src||j(l.src,f)||f.has1x||(f.srcset+=", "+l.src,f.cands.push({url:l.src,x:1,set:f}))):l.src&&l.sets.push({srcset:l.src,sizes:null}),l.curCan=null,l.curSrc=c,l.supported=!(i||f&&!v.supSrcset||g),h&&v.supSrcset&&!l.supported&&(e?(z.call(a,F,e),a.srcset=""):A.call(a,F)),l.supported&&!l.srcset&&(!l.src&&a.src||a.src!=v.makeUrl(l.src))&&(null==l.src?a.removeAttribute("src"):a.src=l.src),l.parsed=!0},v.fillImg=function(a,b){var c,d,e=b.reselect||b.reevaluate;if(a[v.ns]||(a[v.ns]={}),d=a[v.ns],e||d.evaled!=u){if(!d.parsed||b.reevaluate){if(c=a.parentNode,!c)return;v.parseSets(a,c,b)}d.supported?d.evaled=u:g(a)}},v.setupRun=function(b){(!X||R||U!=a.devicePixelRatio)&&(e(),b.elements||b.context||clearTimeout(t))},v.supPicture?(ab=w,v.fillImg=w):(b.createElement("picture"),function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";h=setTimeout(e,"loading"==a?200:999),b.body&&(c=c||d.test(a),v.fillImgs(),c&&clearTimeout(h))},f=function(){v.fillImgs()},g=function(){clearTimeout(t),R=!0,t=setTimeout(f,99)},h=setTimeout(e,b.body?0:20);Y(a,"resize",g),Y(b,"readystatechange",e)}()),v.respimage=ab,v.fillImgs=ab,v.teardownRun=w,ab._=v,a.respimage=a.picturefill||ab,!a.picturefill)for(a.respimgCFG={ri:v,push:function(a){var b=a.shift();"function"==typeof v[b]?v[b].apply(v,a):(D[b]=a[0],X&&v.fillImgs({reselect:!0}))}};O&&O.length;)a.respimgCFG.push(O.shift());a.picturefill||(a.picturefill=a.respimage,a.picturefillCFG||(a.picturefillCFG=a.respimgCFG))}(window,document);

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	
	window.show_quote_form = function() {
	  $.magnificPopup.open({
	    mainClass: 'mfp-fade',
	    removalDelay: 400,
	    overflowY: 'scroll',
	    callbacks: {
	      close: function () {
	        var $scope = angular.element($('.search-block,.stage_teo_main')[0]).scope();
	        $scope.quote.popupcar = false;
	      }
	    },
	    items: [
	      {
	        type: 'inline',
	        src: 'footer .quote-form'
	      }
	    ]
	  })
	}
	
	window.scrollProperties = function() {
	  var prev = current = 0, dir = false;
	  window.addEventListener('scroll', function () {
	    current = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
	    dir = prev > current;
	    prev = current;
	  });
	  return {
	    up: function () {
	      return dir;
	    },
	    pos: function () {
	      return current;
	    }
	  }
	}
	window.scrol = new scrollProperties();
	
	window.scroll_to_search_form = function(cb) {
	  var search_form = $('.search-block');
	  $(window).scrollTo(search_form, 500, cb);
	}
	window.isMobile = function() {
	  return document.body.clientWidth < 650;
	}
	
	window.isMobileOs = function() {
	  return /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(navigator.appVersion);
	}
	


/***/ },
/* 8 */
/***/ function(module, exports) {

	// Magnific Popup v0.9.9 by Dmitry Semenov
	// http://bit.ly/magnific-popup#build=inline+retina+imagezoom+fastclick
	(function(a){var b="Close",c="BeforeClose",d="AfterClose",e="BeforeAppend",f="MarkupParse",g="Open",h="Change",i="mfp",j="."+i,k="mfp-ready",l="mfp-removing",m="mfp-prevent-close",n,o=function(){},p=!!window.jQuery,q,r=a(window),s,t,u,v,w,x=function(a,b){n.ev.on(i+a+j,b)},y=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},z=function(b,c){n.ev.triggerHandler(i+b,c),n.st.callbacks&&(b=b.charAt(0).toLowerCase()+b.slice(1),n.st.callbacks[b]&&n.st.callbacks[b].apply(n,a.isArray(c)?c:[c]))},A=function(b){if(b!==w||!n.currTemplate.closeBtn)n.currTemplate.closeBtn=a(n.st.closeMarkup.replace("%title%",n.st.tClose)),w=b;return n.currTemplate.closeBtn},B=function(){a.magnificPopup.instance||(n=new o,n.init(),a.magnificPopup.instance=n)},C=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(a.transition!==undefined)return!0;while(b.length)if(b.pop()+"Transition"in a)return!0;return!1};o.prototype={constructor:o,init:function(){var b=navigator.appVersion;n.isIE7=b.indexOf("MSIE 7.")!==-1,n.isIE8=b.indexOf("MSIE 8.")!==-1,n.isLowIE=n.isIE7||n.isIE8,n.isAndroid=/android/gi.test(b),n.isIOS=/iphone|ipad|ipod/gi.test(b),n.supportsTransition=C(),n.probablyMobile=n.isAndroid||n.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),t=a(document),n.popupsCache={}},open:function(b){s||(s=a(document.body));var c;if(b.isObj===!1){n.items=b.items.toArray(),n.index=0;var d=b.items,e;for(c=0;c<d.length;c++){e=d[c],e.parsed&&(e=e.el[0]);if(e===b.el[0]){n.index=c;break}}}else n.items=a.isArray(b.items)?b.items:[b.items],n.index=b.index||0;if(n.isOpen){n.updateItemHTML();return}n.types=[],v="",b.mainEl&&b.mainEl.length?n.ev=b.mainEl.eq(0):n.ev=t,b.key?(n.popupsCache[b.key]||(n.popupsCache[b.key]={}),n.currTemplate=n.popupsCache[b.key]):n.currTemplate={},n.st=a.extend(!0,{},a.magnificPopup.defaults,b),n.fixedContentPos=n.st.fixedContentPos==="auto"?!n.probablyMobile:n.st.fixedContentPos,n.st.modal&&(n.st.closeOnContentClick=!1,n.st.closeOnBgClick=!1,n.st.showCloseBtn=!1,n.st.enableEscapeKey=!1),n.bgOverlay||(n.bgOverlay=y("bg").on("click"+j,function(){n.close()}),n.wrap=y("wrap").attr("tabindex",-1).on("click"+j,function(a){n._checkIfClose(a.target)&&n.close()}),n.container=y("container",n.wrap)),n.contentContainer=y("content"),n.st.preloader&&(n.preloader=y("preloader",n.container,n.st.tLoading));var h=a.magnificPopup.modules;for(c=0;c<h.length;c++){var i=h[c];i=i.charAt(0).toUpperCase()+i.slice(1),n["init"+i].call(n)}z("BeforeOpen"),n.st.showCloseBtn&&(n.st.closeBtnInside?(x(f,function(a,b,c,d){c.close_replaceWith=A(d.type)}),v+=" mfp-close-btn-in"):n.wrap.append(A())),n.st.alignTop&&(v+=" mfp-align-top"),n.fixedContentPos?n.wrap.css({overflow:n.st.overflowY,overflowX:"hidden",overflowY:n.st.overflowY}):n.wrap.css({top:r.scrollTop(),position:"absolute"}),(n.st.fixedBgPos===!1||n.st.fixedBgPos==="auto"&&!n.fixedContentPos)&&n.bgOverlay.css({height:t.height(),position:"absolute"}),n.st.enableEscapeKey&&t.on("keyup"+j,function(a){a.keyCode===27&&n.close()}),r.on("resize"+j,function(){n.updateSize()}),n.st.closeOnContentClick||(v+=" mfp-auto-cursor"),v&&n.wrap.addClass(v);var l=n.wH=r.height(),m={};if(n.fixedContentPos&&n._hasScrollBar(l)){var o=n._getScrollbarSize();o&&(m.marginRight=o)}n.fixedContentPos&&(n.isIE7?a("body, html").css("overflow","hidden"):m.overflow="hidden");var p=n.st.mainClass;return n.isIE7&&(p+=" mfp-ie7"),p&&n._addClassToMFP(p),n.updateItemHTML(),z("BuildControls"),a("html").css(m),n.bgOverlay.add(n.wrap).prependTo(n.st.prependTo||s),n._lastFocusedEl=document.activeElement,setTimeout(function(){n.content?(n._addClassToMFP(k),n._setFocus()):n.bgOverlay.addClass(k),t.on("focusin"+j,n._onFocusIn)},16),n.isOpen=!0,n.updateSize(l),z(g),b},close:function(){if(!n.isOpen)return;z(c),n.isOpen=!1,n.st.removalDelay&&!n.isLowIE&&n.supportsTransition?(n._addClassToMFP(l),setTimeout(function(){n._close()},n.st.removalDelay)):n._close()},_close:function(){z(b);var c=l+" "+k+" ";n.bgOverlay.detach(),n.wrap.detach(),n.container.empty(),n.st.mainClass&&(c+=n.st.mainClass+" "),n._removeClassFromMFP(c);if(n.fixedContentPos){var e={marginRight:""};n.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}t.off("keyup"+j+" focusin"+j),n.ev.off(j),n.wrap.attr("class","mfp-wrap").removeAttr("style"),n.bgOverlay.attr("class","mfp-bg"),n.container.attr("class","mfp-container"),n.st.showCloseBtn&&(!n.st.closeBtnInside||n.currTemplate[n.currItem.type]===!0)&&n.currTemplate.closeBtn&&n.currTemplate.closeBtn.detach(),n._lastFocusedEl&&a(n._lastFocusedEl).focus(),n.currItem=null,n.content=null,n.currTemplate=null,n.prevHeight=0,z(d)},updateSize:function(a){if(n.isIOS){var b=document.documentElement.clientWidth/window.innerWidth,c=window.innerHeight*b;n.wrap.css("height",c),n.wH=c}else n.wH=a||r.height();n.fixedContentPos||n.wrap.css("height",n.wH),z("Resize")},updateItemHTML:function(){var b=n.items[n.index];n.contentContainer.detach(),n.content&&n.content.detach(),b.parsed||(b=n.parseEl(n.index));var c=b.type;z("BeforeChange",[n.currItem?n.currItem.type:"",c]),n.currItem=b;if(!n.currTemplate[c]){var d=n.st[c]?n.st[c].markup:!1;z("FirstMarkupParse",d),d?n.currTemplate[c]=a(d):n.currTemplate[c]=!0}u&&u!==b.type&&n.container.removeClass("mfp-"+u+"-holder");var e=n["get"+c.charAt(0).toUpperCase()+c.slice(1)](b,n.currTemplate[c]);n.appendContent(e,c),b.preloaded=!0,z(h,b),u=b.type,n.container.prepend(n.contentContainer),z("AfterChange")},appendContent:function(a,b){n.content=a,a?n.st.showCloseBtn&&n.st.closeBtnInside&&n.currTemplate[b]===!0?n.content.find(".mfp-close").length||n.content.append(A()):n.content=a:n.content="",z(e),n.container.addClass("mfp-"+b+"-holder"),n.contentContainer.append(n.content)},parseEl:function(b){var c=n.items[b],d;c.tagName?c={el:a(c)}:(d=c.type,c={data:c,src:c.src});if(c.el){var e=n.types;for(var f=0;f<e.length;f++)if(c.el.hasClass("mfp-"+e[f])){d=e[f];break}c.src=c.el.attr("data-mfp-src"),c.src||(c.src=c.el.attr("href"))}return c.type=d||n.st.type||"inline",c.index=b,c.parsed=!0,n.items[b]=c,z("ElementParse",c),n.items[b]},addGroup:function(a,b){var c=function(c){c.mfpEl=this,n._openClick(c,a,b)};b||(b={});var d="click.magnificPopup";b.mainEl=a,b.items?(b.isObj=!0,a.off(d).on(d,c)):(b.isObj=!1,b.delegate?a.off(d).on(d,b.delegate,c):(b.items=a,a.off(d).on(d,c)))},_openClick:function(b,c,d){var e=d.midClick!==undefined?d.midClick:a.magnificPopup.defaults.midClick;if(!e&&(b.which===2||b.ctrlKey||b.metaKey))return;var f=d.disableOn!==undefined?d.disableOn:a.magnificPopup.defaults.disableOn;if(f)if(a.isFunction(f)){if(!f.call(n))return!0}else if(r.width()<f)return!0;b.type&&(b.preventDefault(),n.isOpen&&b.stopPropagation()),d.el=a(b.mfpEl),d.delegate&&(d.items=c.find(d.delegate)),n.open(d)},updateStatus:function(a,b){if(n.preloader){q!==a&&n.container.removeClass("mfp-s-"+q),!b&&a==="loading"&&(b=n.st.tLoading);var c={status:a,text:b};z("UpdateStatus",c),a=c.status,b=c.text,n.preloader.html(b),n.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),n.container.addClass("mfp-s-"+a),q=a}},_checkIfClose:function(b){if(a(b).hasClass(m))return;var c=n.st.closeOnContentClick,d=n.st.closeOnBgClick;if(c&&d)return!0;if(!n.content||a(b).hasClass("mfp-close")||n.preloader&&b===n.preloader[0])return!0;if(b!==n.content[0]&&!a.contains(n.content[0],b)){if(d&&a.contains(document,b))return!0}else if(c)return!0;return!1},_addClassToMFP:function(a){n.bgOverlay.addClass(a),n.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),n.wrap.removeClass(a)},_hasScrollBar:function(a){return(n.isIE7?t.height():document.body.scrollHeight)>(a||r.height())},_setFocus:function(){(n.st.focus?n.content.find(n.st.focus).eq(0):n.wrap).focus()},_onFocusIn:function(b){if(b.target!==n.wrap[0]&&!a.contains(n.wrap[0],b.target))return n._setFocus(),!1},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),z(f,[b,c,d]),a.each(c,function(a,c){if(c===undefined||c===!1)return!0;e=a.split("_");if(e.length>1){var d=b.find(j+"-"+e[0]);if(d.length>0){var f=e[1];f==="replaceWith"?d[0]!==c[0]&&d.replaceWith(c):f==="img"?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(j+"-"+a).html(c)})},_getScrollbarSize:function(){if(n.scrollbarSize===undefined){var a=document.createElement("div");a.id="mfp-sbm",a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),n.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return n.scrollbarSize}},a.magnificPopup={instance:null,proto:o.prototype,modules:[],open:function(b,c){return B(),b?b=a.extend(!0,{},b):b={},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(b){B();var c=a(this);if(typeof b=="string")if(b==="open"){var d,e=p?c.data("magnificPopup"):c[0].magnificPopup,f=parseInt(arguments[1],10)||0;e.items?d=e.items[f]:(d=c,e.delegate&&(d=d.find(e.delegate)),d=d.eq(f)),n._openClick({mfpEl:d},c,e)}else n.isOpen&&n[b].apply(n,Array.prototype.slice.call(arguments,1));else b=a.extend(!0,{},b),p?c.data("magnificPopup",b):c[0].magnificPopup=b,n.addGroup(c,b);return c};var D="inline",E,F,G,H=function(){G&&(F.after(G.addClass(E)).detach(),G=null)};a.magnificPopup.registerModule(D,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){n.types.push(D),x(b+"."+D,function(){H()})},getInline:function(b,c){H();if(b.src){var d=n.st.inline,e=a(b.src);if(e.length){var f=e[0].parentNode;f&&f.tagName&&(F||(E=d.hiddenClass,F=y(E),E="mfp-"+E),G=e.after(F).detach().removeClass(E)),n.updateStatus("ready")}else n.updateStatus("error",d.tNotFound),e=a("<div>");return b.inlineElement=e,e}return n.updateStatus("ready"),n._parseMarkup(c,{},b),c}}});var I,J=function(){return I===undefined&&(I=document.createElement("p").style.MozTransform!==undefined),I};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a=n.st.zoom,d=".zoom",e;if(!a.enabled||!n.supportsTransition)return;var f=a.duration,g=function(b){var c=b.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+a.duration/1e3+"s "+a.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,c.css(e),c},h=function(){n.content.css("visibility","visible")},i,j;x("BuildControls"+d,function(){if(n._allowZoom()){clearTimeout(i),n.content.css("visibility","hidden"),e=n._getItemToZoom();if(!e){h();return}j=g(e),j.css(n._getOffset()),n.wrap.append(j),i=setTimeout(function(){j.css(n._getOffset(!0)),i=setTimeout(function(){h(),setTimeout(function(){j.remove(),e=j=null,z("ZoomAnimationEnded")},16)},f)},16)}}),x(c+d,function(){if(n._allowZoom()){clearTimeout(i),n.st.removalDelay=f;if(!e){e=n._getItemToZoom();if(!e)return;j=g(e)}j.css(n._getOffset(!0)),n.wrap.append(j),n.content.css("visibility","hidden"),setTimeout(function(){j.css(n._getOffset())},16)}}),x(b+d,function(){n._allowZoom()&&(h(),j&&j.remove(),e=null)})},_allowZoom:function(){return n.currItem.type==="image"},_getItemToZoom:function(){return n.currItem.hasSize?n.currItem.img:!1},_getOffset:function(b){var c;b?c=n.currItem.img:c=n.st.zoom.opener(n.currItem.el||n.currItem);var d=c.offset(),e=parseInt(c.css("padding-top"),10),f=parseInt(c.css("padding-bottom"),10);d.top-=a(window).scrollTop()-e;var g={width:c.width(),height:(p?c.innerHeight():c[0].offsetHeight)-f-e};return J()?g["-moz-transform"]=g.transform="translate("+d.left+"px,"+d.top+"px)":(g.left=d.left,g.top=d.top),g}}});var K="retina";a.magnificPopup.registerModule(K,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=n.st.retina,b=a.ratio;b=isNaN(b)?b():b,b>1&&(x("ImageHasSize."+K,function(a,c){c.img.css({"max-width":c.img[0].naturalWidth/b,width:"100%"})}),x("ElementParse."+K,function(c,d){d.src=a.replaceSrc(d,b)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){r.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g=a(this),h;if(c){var i,j,k,l,m,n;g.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,r.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0];if(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)l=!0,d()}).on("touchend"+f,function(a){d();if(l||n>1)return;h=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){h=!1},b),e()})})}g.on("click"+f,function(){h||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&r.off("touchmove"+f+" touchend"+f)}}(),B()})(window.jQuery||window.Zepto)


/***/ },
/* 9 */
/***/ function(module, exports) {

	/*
	 * Hashcode.js 1.0.2
	 * https://github.com/stuartbannerman/hashcode
	 *
	 * Copyright 2013 Stuart Bannerman (me@stuartbannerman.com)
	 * Released under the MIT license
	 *
	 * Date: 07-04-2013
	 */
	
	(function(window)
	{
	    window.Hashcode = (function()
	    {
	        // Used to check objects for own properties
	        var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	        // Hashes a string
	        var hash = function(string)
	        {
	            var string = string.toString(), hash = 0, i;
	            for (i = 0; i < string.length; i++)
	            {
	                hash = (((hash << 5) - hash) + string.charCodeAt(i)) & 0xFFFFFFFF;
	            }
	
	            return hash;
	        };
	        // Deep hashes an object
	        var object = function(obj)
	        {
	            if (typeof obj.getTime=='function') return obj.getTime();
	            var result = 0;
	            for(var property in obj)
	            {
	                if(hasOwnProperty.call(obj, property))
	                {
	                    result += hash(property + value(obj[property]));
	                }
	            }
	
	            return result;
	        };
	        // Does a type check on the passed in value and calls the appropriate hash method
	        var value = function(value)
	        {
	            var types =
	            {
	                'string' : hash,
	                'number' : hash,
	                'boolean' : hash,
	                'object' : object
	                // functions are excluded because they are not representative of the state of an object
	                // types 'undefined' or 'null' will have a hash of 0
	            };
	            var type = typeof value;
	
	            return value != null && types[type] ? types[type](value) + hash(type) : 0;
	        };
	
	        return {
	            value: value
	        };
	    })();
	})(window);


/***/ },
/* 10 */
/***/ function(module, exports) {

	/*!
	 * modernizr v3.3.1
	 * Build http://modernizr.com/download?-cssanimations-csscolumns-flexbox-inputtypes-setclasses-dontmin
	 *
	 * Copyright (c)
	 *  Faruk Ates
	 *  Paul Irish
	 *  Alex Sexton
	 *  Ryan Seddon
	 *  Patrick Kettner
	 *  Stu Cox
	 *  Richard Herrera
	
	 * MIT License
	 */
	
	/*
	 * Modernizr tests which native CSS3 and HTML5 features are available in the
	 * current UA and makes the results available to you in two ways: as properties on
	 * a global `Modernizr` object, and as classes on the `<html>` element. This
	 * information allows you to progressively enhance your pages with a granular level
	 * of control over the experience.
	*/
	
	;(function(window, document, undefined){
	  var classes = [];
	  
	
	  var tests = [];
	  
	
	  /**
	   *
	   * ModernizrProto is the constructor for Modernizr
	   *
	   * @class
	   * @access public
	   */
	
	  var ModernizrProto = {
	    // The current version, dummy
	    _version: '3.3.1',
	
	    // Any settings that don't work as separate modules
	    // can go in here as configuration.
	    _config: {
	      'classPrefix': '',
	      'enableClasses': true,
	      'enableJSClass': true,
	      'usePrefixes': true
	    },
	
	    // Queue of tests
	    _q: [],
	
	    // Stub these for people who are listening
	    on: function(test, cb) {
	      // I don't really think people should do this, but we can
	      // safe guard it a bit.
	      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
	      // This is in case people listen to synchronous tests. I would leave it out,
	      // but the code to *disallow* sync tests in the real version of this
	      // function is actually larger than this.
	      var self = this;
	      setTimeout(function() {
	        cb(self[test]);
	      }, 0);
	    },
	
	    addTest: function(name, fn, options) {
	      tests.push({name: name, fn: fn, options: options});
	    },
	
	    addAsyncTest: function(fn) {
	      tests.push({name: null, fn: fn});
	    }
	  };
	
	  
	
	  // Fake some of Object.create so we can force non test results to be non "own" properties.
	  var Modernizr = function() {};
	  Modernizr.prototype = ModernizrProto;
	
	  // Leak modernizr globally when you `require` it rather than force it here.
	  // Overwrite name so constructor name is nicer :D
	  Modernizr = new Modernizr();
	
	  
	
	  /**
	   * is returns a boolean if the typeof an obj is exactly type.
	   *
	   * @access private
	   * @function is
	   * @param {*} obj - A thing we want to check the type of
	   * @param {string} type - A string to compare the typeof against
	   * @returns {boolean}
	   */
	
	  function is(obj, type) {
	    return typeof obj === type;
	  }
	  ;
	
	  /**
	   * Run through all tests and detect their support in the current UA.
	   *
	   * @access private
	   */
	
	  function testRunner() {
	    var featureNames;
	    var feature;
	    var aliasIdx;
	    var result;
	    var nameIdx;
	    var featureName;
	    var featureNameSplit;
	
	    for (var featureIdx in tests) {
	      if (tests.hasOwnProperty(featureIdx)) {
	        featureNames = [];
	        feature = tests[featureIdx];
	        // run the test, throw the return value into the Modernizr,
	        // then based on that boolean, define an appropriate className
	        // and push it into an array of classes we'll join later.
	        //
	        // If there is no name, it's an 'async' test that is run,
	        // but not directly added to the object. That should
	        // be done with a post-run addTest call.
	        if (feature.name) {
	          featureNames.push(feature.name.toLowerCase());
	
	          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
	            // Add all the aliases into the names list
	            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
	              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
	            }
	          }
	        }
	
	        // Run the test, or use the raw value if it's not a function
	        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;
	
	
	        // Set each of the names on the Modernizr object
	        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
	          featureName = featureNames[nameIdx];
	          // Support dot properties as sub tests. We don't do checking to make sure
	          // that the implied parent tests have been added. You must call them in
	          // order (either in the test, or make the parent test a dependency).
	          //
	          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
	          // hashtag famous last words
	          featureNameSplit = featureName.split('.');
	
	          if (featureNameSplit.length === 1) {
	            Modernizr[featureNameSplit[0]] = result;
	          } else {
	            // cast to a Boolean, if not one already
	            /* jshint -W053 */
	            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
	              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
	            }
	
	            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
	          }
	
	          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
	        }
	      }
	    }
	  }
	  ;
	
	  /**
	   * docElement is a convenience wrapper to grab the root element of the document
	   *
	   * @access private
	   * @returns {HTMLElement|SVGElement} The root element of the document
	   */
	
	  var docElement = document.documentElement;
	  
	
	  /**
	   * A convenience helper to check if the document we are running in is an SVG document
	   *
	   * @access private
	   * @returns {boolean}
	   */
	
	  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
	  
	
	  /**
	   * setClasses takes an array of class names and adds them to the root element
	   *
	   * @access private
	   * @function setClasses
	   * @param {string[]} classes - Array of class names
	   */
	
	  // Pass in an and array of class names, e.g.:
	  //  ['no-webp', 'borderradius', ...]
	  function setClasses(classes) {
	    var className = docElement.className;
	    var classPrefix = Modernizr._config.classPrefix || '';
	
	    if (isSVG) {
	      className = className.baseVal;
	    }
	
	    // Change `no-js` to `js` (independently of the `enableClasses` option)
	    // Handle classPrefix on this too
	    if (Modernizr._config.enableJSClass) {
	      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
	      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
	    }
	
	    if (Modernizr._config.enableClasses) {
	      // Add the new classes
	      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
	      isSVG ? docElement.className.baseVal = className : docElement.className = className;
	    }
	
	  }
	
	  ;
	
	  /**
	   * createElement is a convenience wrapper around document.createElement. Since we
	   * use createElement all over the place, this allows for (slightly) smaller code
	   * as well as abstracting away issues with creating elements in contexts other than
	   * HTML documents (e.g. SVG documents).
	   *
	   * @access private
	   * @function createElement
	   * @returns {HTMLElement|SVGElement} An HTML or SVG element
	   */
	
	  function createElement() {
	    if (typeof document.createElement !== 'function') {
	      // This is the case in IE7, where the type of createElement is "object".
	      // For this reason, we cannot call apply() as Object is not a Function.
	      return document.createElement(arguments[0]);
	    } else if (isSVG) {
	      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
	    } else {
	      return document.createElement.apply(document, arguments);
	    }
	  }
	
	  ;
	
	  /**
	   * since we have a fairly large number of input tests that don't mutate the input
	   * we create a single element that can be shared with all of those tests for a
	   * minor perf boost
	   *
	   * @access private
	   * @returns {HTMLInputElement}
	   */
	  var inputElem = createElement('input');
	  
	/*!
	{
	  "name": "Form input types",
	  "property": "inputtypes",
	  "caniuse": "forms",
	  "tags": ["forms"],
	  "authors": ["Mike Taylor"],
	  "polyfills": [
	    "jquerytools",
	    "webshims",
	    "h5f",
	    "webforms2",
	    "nwxforms",
	    "fdslider",
	    "html5slider",
	    "galleryhtml5forms",
	    "jscolor",
	    "html5formshim",
	    "selectedoptionsjs",
	    "formvalidationjs"
	  ]
	}
	!*/
	/* DOC
	Detects support for HTML5 form input types and exposes Boolean subproperties with the results:
	
	```javascript
	Modernizr.inputtypes.color
	Modernizr.inputtypes.date
	Modernizr.inputtypes.datetime
	Modernizr.inputtypes['datetime-local']
	Modernizr.inputtypes.email
	Modernizr.inputtypes.month
	Modernizr.inputtypes.number
	Modernizr.inputtypes.range
	Modernizr.inputtypes.search
	Modernizr.inputtypes.tel
	Modernizr.inputtypes.time
	Modernizr.inputtypes.url
	Modernizr.inputtypes.week
	```
	*/
	
	  // Run through HTML5's new input types to see if the UA understands any.
	  //   This is put behind the tests runloop because it doesn't return a
	  //   true/false like all the other tests; instead, it returns an object
	  //   containing each input type with its corresponding true/false value
	
	  // Big thanks to @miketaylr for the html5 forms expertise. miketaylr.com/
	  var inputtypes = 'search tel url email datetime date month week time datetime-local number range color'.split(' ');
	  var inputs = {};
	
	  Modernizr.inputtypes = (function(props) {
	    var len = props.length;
	    var smile = '1)';
	    var inputElemType;
	    var defaultView;
	    var bool;
	
	    for (var i = 0; i < len; i++) {
	
	      inputElem.setAttribute('type', inputElemType = props[i]);
	      bool = inputElem.type !== 'text' && 'style' in inputElem;
	
	      // We first check to see if the type we give it sticks..
	      // If the type does, we feed it a textual value, which shouldn't be valid.
	      // If the value doesn't stick, we know there's input sanitization which infers a custom UI
	      if (bool) {
	
	        inputElem.value         = smile;
	        inputElem.style.cssText = 'position:absolute;visibility:hidden;';
	
	        if (/^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined) {
	
	          docElement.appendChild(inputElem);
	          defaultView = document.defaultView;
	
	          // Safari 2-4 allows the smiley as a value, despite making a slider
	          bool =  defaultView.getComputedStyle &&
	            defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
	            // Mobile android web browser has false positive, so must
	            // check the height to see if the widget is actually there.
	            (inputElem.offsetHeight !== 0);
	
	          docElement.removeChild(inputElem);
	
	        } else if (/^(search|tel)$/.test(inputElemType)) {
	          // Spec doesn't define any special parsing or detectable UI
	          //   behaviors so we pass these through as true
	
	          // Interestingly, opera fails the earlier test, so it doesn't
	          //  even make it here.
	
	        } else if (/^(url|email)$/.test(inputElemType)) {
	          // Real url and email support comes with prebaked validation.
	          bool = inputElem.checkValidity && inputElem.checkValidity() === false;
	
	        } else {
	          // If the upgraded input compontent rejects the :) text, we got a winner
	          bool = inputElem.value != smile;
	        }
	      }
	
	      inputs[ props[i] ] = !!bool;
	    }
	    return inputs;
	  })(inputtypes);
	
	
	  /**
	   * If the browsers follow the spec, then they would expose vendor-specific style as:
	   *   elem.style.WebkitBorderRadius
	   * instead of something like the following, which would be technically incorrect:
	   *   elem.style.webkitBorderRadius
	
	   * Webkit ghosts their properties in lowercase but Opera & Moz do not.
	   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
	   *   erik.eae.net/archives/2008/03/10/21.48.10/
	
	   * More here: github.com/Modernizr/Modernizr/issues/issue/21
	   *
	   * @access private
	   * @returns {string} The string representing the vendor-specific style properties
	   */
	
	  var omPrefixes = 'Moz O ms Webkit';
	  
	
	  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
	  ModernizrProto._cssomPrefixes = cssomPrefixes;
	  
	
	  /**
	   * List of JavaScript DOM values used for tests
	   *
	   * @memberof Modernizr
	   * @name Modernizr._domPrefixes
	   * @optionName Modernizr._domPrefixes
	   * @optionProp domPrefixes
	   * @access public
	   * @example
	   *
	   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
	   * than kebab-case properties, all properties are their Capitalized variant
	   *
	   * ```js
	   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
	   * ```
	   */
	
	  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
	  ModernizrProto._domPrefixes = domPrefixes;
	  
	
	
	  /**
	   * contains checks to see if a string contains another string
	   *
	   * @access private
	   * @function contains
	   * @param {string} str - The string we want to check for substrings
	   * @param {string} substr - The substring we want to search the first string for
	   * @returns {boolean}
	   */
	
	  function contains(str, substr) {
	    return !!~('' + str).indexOf(substr);
	  }
	
	  ;
	
	  /**
	   * cssToDOM takes a kebab-case string and converts it to camelCase
	   * e.g. box-sizing -> boxSizing
	   *
	   * @access private
	   * @function cssToDOM
	   * @param {string} name - String name of kebab-case prop we want to convert
	   * @returns {string} The camelCase version of the supplied name
	   */
	
	  function cssToDOM(name) {
	    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
	      return m1 + m2.toUpperCase();
	    }).replace(/^-/, '');
	  }
	  ;
	
	  /**
	   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
	   *
	   * @access private
	   * @function fnBind
	   * @param {function} fn - a function you want to change `this` reference to
	   * @param {object} that - the `this` you want to call the function with
	   * @returns {function} The wrapped version of the supplied function
	   */
	
	  function fnBind(fn, that) {
	    return function() {
	      return fn.apply(that, arguments);
	    };
	  }
	
	  ;
	
	  /**
	   * testDOMProps is a generic DOM property test; if a browser supports
	   *   a certain property, it won't return undefined for it.
	   *
	   * @access private
	   * @function testDOMProps
	   * @param {array.<string>} props - An array of properties to test for
	   * @param {object} obj - An object or Element you want to use to test the parameters again
	   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
	   */
	  function testDOMProps(props, obj, elem) {
	    var item;
	
	    for (var i in props) {
	      if (props[i] in obj) {
	
	        // return the property name as a string
	        if (elem === false) {
	          return props[i];
	        }
	
	        item = obj[props[i]];
	
	        // let's bind a function
	        if (is(item, 'function')) {
	          // bind to obj unless overriden
	          return fnBind(item, elem || obj);
	        }
	
	        // return the unbound function or obj or value
	        return item;
	      }
	    }
	    return false;
	  }
	
	  ;
	
	  /**
	   * Create our "modernizr" element that we do most feature tests on.
	   *
	   * @access private
	   */
	
	  var modElem = {
	    elem: createElement('modernizr')
	  };
	
	  // Clean up this element
	  Modernizr._q.push(function() {
	    delete modElem.elem;
	  });
	
	  
	
	  var mStyle = {
	    style: modElem.elem.style
	  };
	
	  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
	  // the front of the queue.
	  Modernizr._q.unshift(function() {
	    delete mStyle.style;
	  });
	
	  
	
	  /**
	   * domToCSS takes a camelCase string and converts it to kebab-case
	   * e.g. boxSizing -> box-sizing
	   *
	   * @access private
	   * @function domToCSS
	   * @param {string} name - String name of camelCase prop we want to convert
	   * @returns {string} The kebab-case version of the supplied name
	   */
	
	  function domToCSS(name) {
	    return name.replace(/([A-Z])/g, function(str, m1) {
	      return '-' + m1.toLowerCase();
	    }).replace(/^ms-/, '-ms-');
	  }
	  ;
	
	  /**
	   * getBody returns the body of a document, or an element that can stand in for
	   * the body if a real body does not exist
	   *
	   * @access private
	   * @function getBody
	   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
	   * artificially created element that stands in for the body
	   */
	
	  function getBody() {
	    // After page load injecting a fake body doesn't work so check if body exists
	    var body = document.body;
	
	    if (!body) {
	      // Can't use the real body create a fake one.
	      body = createElement(isSVG ? 'svg' : 'body');
	      body.fake = true;
	    }
	
	    return body;
	  }
	
	  ;
	
	  /**
	   * injectElementWithStyles injects an element with style element and some CSS rules
	   *
	   * @access private
	   * @function injectElementWithStyles
	   * @param {string} rule - String representing a css rule
	   * @param {function} callback - A function that is used to test the injected element
	   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
	   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
	   * @returns {boolean}
	   */
	
	  function injectElementWithStyles(rule, callback, nodes, testnames) {
	    var mod = 'modernizr';
	    var style;
	    var ret;
	    var node;
	    var docOverflow;
	    var div = createElement('div');
	    var body = getBody();
	
	    if (parseInt(nodes, 10)) {
	      // In order not to give false positives we create a node for each test
	      // This also allows the method to scale for unspecified uses
	      while (nodes--) {
	        node = createElement('div');
	        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	        div.appendChild(node);
	      }
	    }
	
	    style = createElement('style');
	    style.type = 'text/css';
	    style.id = 's' + mod;
	
	    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
	    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
	    (!body.fake ? div : body).appendChild(style);
	    body.appendChild(div);
	
	    if (style.styleSheet) {
	      style.styleSheet.cssText = rule;
	    } else {
	      style.appendChild(document.createTextNode(rule));
	    }
	    div.id = mod;
	
	    if (body.fake) {
	      //avoid crashing IE8, if background image is used
	      body.style.background = '';
	      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
	      body.style.overflow = 'hidden';
	      docOverflow = docElement.style.overflow;
	      docElement.style.overflow = 'hidden';
	      docElement.appendChild(body);
	    }
	
	    ret = callback(div, rule);
	    // If this is done after page load we don't want to remove the body so check if body exists
	    if (body.fake) {
	      body.parentNode.removeChild(body);
	      docElement.style.overflow = docOverflow;
	      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
	      docElement.offsetHeight;
	    } else {
	      div.parentNode.removeChild(div);
	    }
	
	    return !!ret;
	
	  }
	
	  ;
	
	  /**
	   * nativeTestProps allows for us to use native feature detection functionality if available.
	   * some prefixed form, or false, in the case of an unsupported rule
	   *
	   * @access private
	   * @function nativeTestProps
	   * @param {array} props - An array of property names
	   * @param {string} value - A string representing the value we want to check via @supports
	   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
	   */
	
	  // Accepts a list of property names and a single value
	  // Returns `undefined` if native detection not available
	  function nativeTestProps(props, value) {
	    var i = props.length;
	    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
	    if ('CSS' in window && 'supports' in window.CSS) {
	      // Try every prefixed variant of the property
	      while (i--) {
	        if (window.CSS.supports(domToCSS(props[i]), value)) {
	          return true;
	        }
	      }
	      return false;
	    }
	    // Otherwise fall back to at-rule (for Opera 12.x)
	    else if ('CSSSupportsRule' in window) {
	      // Build a condition string for every prefixed variant
	      var conditionText = [];
	      while (i--) {
	        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
	      }
	      conditionText = conditionText.join(' or ');
	      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
	        return getComputedStyle(node, null).position == 'absolute';
	      });
	    }
	    return undefined;
	  }
	  ;
	
	  // testProps is a generic CSS / DOM property test.
	
	  // In testing support for a given CSS property, it's legit to test:
	  //    `elem.style[styleName] !== undefined`
	  // If the property is supported it will return an empty string,
	  // if unsupported it will return undefined.
	
	  // We'll take advantage of this quick test and skip setting a style
	  // on our modernizr element, but instead just testing undefined vs
	  // empty string.
	
	  // Property names can be provided in either camelCase or kebab-case.
	
	  function testProps(props, prefixed, value, skipValueTest) {
	    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;
	
	    // Try native detect first
	    if (!is(value, 'undefined')) {
	      var result = nativeTestProps(props, value);
	      if (!is(result, 'undefined')) {
	        return result;
	      }
	    }
	
	    // Otherwise do it properly
	    var afterInit, i, propsLength, prop, before;
	
	    // If we don't have a style element, that means we're running async or after
	    // the core tests, so we'll need to create our own elements to use
	
	    // inside of an SVG element, in certain browsers, the `style` element is only
	    // defined for valid tags. Therefore, if `modernizr` does not have one, we
	    // fall back to a less used element and hope for the best.
	    var elems = ['modernizr', 'tspan'];
	    while (!mStyle.style) {
	      afterInit = true;
	      mStyle.modElem = createElement(elems.shift());
	      mStyle.style = mStyle.modElem.style;
	    }
	
	    // Delete the objects if we created them.
	    function cleanElems() {
	      if (afterInit) {
	        delete mStyle.style;
	        delete mStyle.modElem;
	      }
	    }
	
	    propsLength = props.length;
	    for (i = 0; i < propsLength; i++) {
	      prop = props[i];
	      before = mStyle.style[prop];
	
	      if (contains(prop, '-')) {
	        prop = cssToDOM(prop);
	      }
	
	      if (mStyle.style[prop] !== undefined) {
	
	        // If value to test has been passed in, do a set-and-check test.
	        // 0 (integer) is a valid property value, so check that `value` isn't
	        // undefined, rather than just checking it's truthy.
	        if (!skipValueTest && !is(value, 'undefined')) {
	
	          // Needs a try catch block because of old IE. This is slow, but will
	          // be avoided in most cases because `skipValueTest` will be used.
	          try {
	            mStyle.style[prop] = value;
	          } catch (e) {}
	
	          // If the property value has changed, we assume the value used is
	          // supported. If `value` is empty string, it'll fail here (because
	          // it hasn't changed), which matches how browsers have implemented
	          // CSS.supports()
	          if (mStyle.style[prop] != before) {
	            cleanElems();
	            return prefixed == 'pfx' ? prop : true;
	          }
	        }
	        // Otherwise just return true, or the property name if this is a
	        // `prefixed()` call
	        else {
	          cleanElems();
	          return prefixed == 'pfx' ? prop : true;
	        }
	      }
	    }
	    cleanElems();
	    return false;
	  }
	
	  ;
	
	  /**
	   * testPropsAll tests a list of DOM properties we want to check against.
	   * We specify literally ALL possible (known and/or likely) properties on
	   * the element including the non-vendor prefixed one, for forward-
	   * compatibility.
	   *
	   * @access private
	   * @function testPropsAll
	   * @param {string} prop - A string of the property to test for
	   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
	   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
	   * @param {string} [value] - A string of a css value
	   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
	   */
	  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {
	
	    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
	    props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');
	
	    // did they call .prefixed('boxSizing') or are we just testing a prop?
	    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
	      return testProps(props, prefixed, value, skipValueTest);
	
	      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
	    } else {
	      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
	      return testDOMProps(props, prefixed, elem);
	    }
	  }
	
	  // Modernizr.testAllProps() investigates whether a given style property,
	  // or any of its vendor-prefixed variants, is recognized
	  //
	  // Note that the property names must be provided in the camelCase variant.
	  // Modernizr.testAllProps('boxSizing')
	  ModernizrProto.testAllProps = testPropsAll;
	
	  
	
	  /**
	   * testAllProps determines whether a given CSS property is supported in the browser
	   *
	   * @memberof Modernizr
	   * @name Modernizr.testAllProps
	   * @optionName Modernizr.testAllProps()
	   * @optionProp testAllProps
	   * @access public
	   * @function testAllProps
	   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
	   * @param {string} [value] - String of the value to test
	   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
	   * @example
	   *
	   * testAllProps determines whether a given CSS property, in some prefixed form,
	   * is supported by the browser.
	   *
	   * ```js
	   * testAllProps('boxSizing')  // true
	   * ```
	   *
	   * It can optionally be given a CSS value in string form to test if a property
	   * value is valid
	   *
	   * ```js
	   * testAllProps('display', 'block') // true
	   * testAllProps('display', 'penguin') // false
	   * ```
	   *
	   * A boolean can be passed as a third parameter to skip the value check when
	   * native detection (@supports) isn't available.
	   *
	   * ```js
	   * testAllProps('shapeOutside', 'content-box', true);
	   * ```
	   */
	
	  function testAllProps(prop, value, skipValueTest) {
	    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
	  }
	  ModernizrProto.testAllProps = testAllProps;
	  
	/*!
	{
	  "name": "CSS Columns",
	  "property": "csscolumns",
	  "caniuse": "multicolumn",
	  "polyfills": ["css3multicolumnjs"],
	  "tags": ["css"]
	}
	!*/
	
	
	  (function() {
	
	    /* jshint -W053 */
	    Modernizr.addTest('csscolumns', function() {
	      var bool = false;
	      var test = testAllProps('columnCount');
	      try {
	        if (bool = !!test) {
	          bool = new Boolean(bool);
	        }
	      } catch (e) {}
	
	      return bool;
	    });
	
	    var props = ['Width', 'Span', 'Fill', 'Gap', 'Rule', 'RuleColor', 'RuleStyle', 'RuleWidth', 'BreakBefore', 'BreakAfter', 'BreakInside'];
	    var name, test;
	
	    for (var i = 0; i < props.length; i++) {
	      name = props[i].toLowerCase();
	      test = testAllProps('column' + props[i]);
	
	      // break-before, break-after & break-inside are not "column"-prefixed in spec
	      if (name === 'breakbefore' || name === 'breakafter' || name == 'breakinside') {
	        test = test || testAllProps(props[i]);
	      }
	
	      Modernizr.addTest('csscolumns.' + name, test);
	    }
	
	
	  })();
	
	
	/*!
	{
	  "name": "CSS Animations",
	  "property": "cssanimations",
	  "caniuse": "css-animation",
	  "polyfills": ["transformie", "csssandpaper"],
	  "tags": ["css"],
	  "warnings": ["Android < 4 will pass this test, but can only animate a single property at a time"],
	  "notes": [{
	    "name" : "Article: 'Dispelling the Android CSS animation myths'",
	    "href": "https://goo.gl/OGw5Gm"
	  }]
	}
	!*/
	/* DOC
	Detects whether or not elements can be animated using CSS
	*/
	
	  Modernizr.addTest('cssanimations', testAllProps('animationName', 'a', true));
	
	/*!
	{
	  "name": "Flexbox",
	  "property": "flexbox",
	  "caniuse": "flexbox",
	  "tags": ["css"],
	  "notes": [{
	    "name": "The _new_ flexbox",
	    "href": "http://dev.w3.org/csswg/css3-flexbox"
	  }],
	  "warnings": [
	    "A `true` result for this detect does not imply that the `flex-wrap` property is supported; see the `flexwrap` detect."
	  ]
	}
	!*/
	/* DOC
	Detects support for the Flexible Box Layout model, a.k.a. Flexbox, which allows easy manipulation of layout order and sizing within a container.
	*/
	
	  Modernizr.addTest('flexbox', testAllProps('flexBasis', '1px', true));
	
	
	  // Run each test
	  testRunner();
	
	  // Remove the "no-js" class if it exists
	  setClasses(classes);
	
	  delete ModernizrProto.addTest;
	  delete ModernizrProto.addAsyncTest;
	
	  // Run the things that are supposed to run after the tests
	  for (var i = 0; i < Modernizr._q.length; i++) {
	    Modernizr._q[i]();
	  }
	
	  // Leak Modernizr namespace
	  window.Modernizr = Modernizr;
	
	
	;
	
	})(window, document);


/***/ },
/* 11 */
/***/ function(module, exports) {

	var atp = atp || {
		Observer : function(update) {
			this.update = update;
		},
		Observable : function() {
				
	
			var observers = [],
				self = this,
				hasChanged = false;
	
			
			this.addObserver = function(observer) {
				if (observers.indexOf(observer) == -1)
					observers.push(observer);
			};
	
			
			this.deleteObserver = function(observer) {
				var index = observers.indexOf(observer);
				if (index != -1)
					observers.splice(index, 1);
			};
	
			
			this.notifyObservers = function() {
				if (self.hasChanged()) {
					for (var i = 0; i < observers.length; i++)
						observers[i].update();
					self.clearChanged();
				}
			};
	
			
			this.hasChanged = function() {
				return hasChanged;
			};
	
			
			this.setChanged = function() {
				hasChanged = true;
			};
	
			
			this.clearChanged = function() {
				hasChanged = false;
			};
	
		},
		Stack : function() {
			var linkedList = null;
			this.push = function(item) {
				linkedList = new atp.Node(item, linkedList);
			};
			this.pop = function() {
				var out = linkedList.data;
				linkedList = linkedList.next;
				return out;
			};
			this.peek = function() {
				return linkedList.data;
			};
			this.isEmpty = function() {
				return !linkedList || linkedList.data == null;
			};
		},
		Node: function(data, next) {
			this.data = data;
			this.next = next;
		},
		status: {
			DISABLED: 1,
			HOURS:    2,
			MINUTES:  3
		}
	};
	(function(atp){
	
		var singletonClass=function() {
			var self = this;
	
			
			var hours = 0;
	
			
			var minutes = 0;
	
			
			this.getMinutes = function() {
				return minutes;
			};
	
			
			this.getHours = function() {
				return hours;
			};
	
			
			this.getStatus = function() {
				return status;
			};
	
			
			this.setMinutes = function(n) {
				if (minutes!=n)
					self.setChanged();
				minutes = n;
				self.notifyObservers();
			};
	
			
			this.setHours = function(n) {
				if (hours!=n)
					self.setChanged();
				hours = n;
				self.notifyObservers();
			};
	
		};
	
		//singeltonClass now extends Observable
		singletonClass.prototype=new atp.Observable;
		singletonClass.constructor=singletonClass;
		atp.state=new singletonClass;
	
	})(atp);
	(function(atp){
		var flexEase=function(t) {
			if (t<1/2)
				return (-1/8)*Math.sin(t*Math.PI*2);
			else
				return t*2 - 1;
		};
	
		var animate=function(opts){
			var step=0, differences={};
			var easing=opts.easing||function(t){return t};
			var styles=opts.styles;
			var element=opts.element;
			var callback=opts.callback;
			var duration=opts.duration;
			var steps=duration/10;
			if (duration===0){
				for (var k in styles)
					if (styles.hasOwnProperty(k))
						element.css(k, styles[k][1]+styles[k][2]);
				if (callback)
					callback();
				return;
			}
			for (var k in styles)
				if (styles.hasOwnProperty(k))
					differences[k]=styles[k][1]-styles[k][0];
	
			var stepFn=function(){
				var factor=easing(step/steps);
				for (var k in styles)
					if (styles.hasOwnProperty(k))
						element.css(k, (styles[k][0]+differences[k]*factor)+styles[k][2]);
				if (++step>steps){
					clearInterval(interval);
					if (callback)
						callback();
				}
			};
			stepFn();
			var interval=setInterval(stepFn, duration/steps);
		};
	
		atp.animate=animate;
		atp.animate.easing={
			flex:flexEase
		};
		
	})(atp);
	/* abstract class atp.ux */
	(function(atp){
	
		var timePromise={}, element, pluginElements, tracking, touched, isAm;
		var statusNow=atp.status.DISABLED;
	
		document.addEventListener('DOMContentLoaded', function(){
			var plugin=makeTemplate();
			document.body.appendChild(plugin);
			bindToElement(plugin);
		});
	
		var makeTemplate=function(){
			
			var template=
			'<div class="atp">'+
			'	<div class="atp-current">'+
			'		<span class="atp-current-hours selected">12</span>'+
			'		<span class="atp-current-seperator">:</span>'+
			'		<span class="atp-current-minutes">00</span>'+
			'		<span class="atp-current-am-pm">AM</span>'+
			'	</div>'+
			'	<div class="atp-clock">'+
			'		<div class="atp-hand"></div>'+
			'		<div class="atp-hours">'+
			'			<div class="atp-num atp-num-top-0 atp-num-left-3">12</div>'+
			'			<div class="atp-num atp-num-top-1 atp-num-left-4">1</div>'+
			'			<div class="atp-num atp-num-top-2 atp-num-left-5">2</div>'+
			'			<div class="atp-num atp-num-top-3 atp-num-left-6">3</div>'+
			'			<div class="atp-num atp-num-top-4 atp-num-left-5">4</div>'+
			'			<div class="atp-num atp-num-top-5 atp-num-left-4">5</div>'+
			'			<div class="atp-num atp-num-top-6 atp-num-left-3">6</div>'+
			'			<div class="atp-num atp-num-top-5 atp-num-left-2">7</div>'+
			'			<div class="atp-num atp-num-top-4 atp-num-left-1">8</div>'+
			'			<div class="atp-num atp-num-top-3 atp-num-left-0">9</div>'+
			'			<div class="atp-num atp-num-top-2 atp-num-left-1">10</div>'+
			'			<div class="atp-num atp-num-top-1 atp-num-left-2">11</div>'+
			'		</div>'+
			'		<div class="atp-minutes">'+
			'			<div class="atp-num atp-num-top-0 atp-num-left-3">0</div>'+
			'			<div class="atp-num atp-num-top-1 atp-num-left-4">5</div>'+
			'			<div class="atp-num atp-num-top-2 atp-num-left-5">10</div>'+
			'			<div class="atp-num atp-num-top-3 atp-num-left-6">15</div>'+
			'			<div class="atp-num atp-num-top-4 atp-num-left-5">20</div>'+
			'			<div class="atp-num atp-num-top-5 atp-num-left-4">25</div>'+
			'			<div class="atp-num atp-num-top-6 atp-num-left-3">30</div>'+
			'			<div class="atp-num atp-num-top-5 atp-num-left-2">35</div>'+
			'			<div class="atp-num atp-num-top-4 atp-num-left-1">40</div>'+
			'			<div class="atp-num atp-num-top-3 atp-num-left-0">45</div>'+
			'			<div class="atp-num atp-num-top-2 atp-num-left-1">50</div>'+
			'			<div class="atp-num atp-num-top-1 atp-num-left-2">55</div>'+
			'		</div>'+
			'		<div class="atp-middle-dot"></div>'+
			'		<div class="atp-cover"></div>'+
			'	</div>'+
			'	<div class="atp-am-pm">'+
			'		<div class="atp-am-select selected">'+
			'			<div>AM</div>'+
			'		</div>'+
			'		<div class="atp-pm-select">'+
			'			<div>PM</div>'+
			'		</div>'+
			'	</div>'+
			'	<div class="atp-buttons">'+
			'		<button class="atp-button atp-button-cancel">cancel</button>'+
			'		<button class="atp-button atp-button-ok">ok</button>'+
			'	</div>'+
			'</div>';
			var div=document.createElement('div');
			div.innerHTML=template.replace(/\t/g, '');
			return div.firstChild;
		};
	
		var refreshView=function(){
	
			var hours=atp.state.getHours();
			var minutes=atp.state.getMinutes();
	
			pluginElements.current.hours.html(
				(hours%12)==0?12:(hours%12)
			);
	
			pluginElements.current.minutes.html(
				formatNumber(minutes)
			);
	
			pluginElements.current.ampm.html(
				hours>=12?"PM":"AM"
			);
	
			if (hours>=12){
				pluginElements.buttons.pm.addClass('selected');
				pluginElements.buttons.am.removeClass('selected');
			}
			else {
				pluginElements.buttons.am.addClass('selected');
				pluginElements.buttons.pm.removeClass('selected');
			}
	
			switch (getStatus()){
				case atp.status.HOURS:
					pluginElements.current.hours.addClass('selected');
					pluginElements.current.minutes.removeClass('selected');
					pluginElements.clock.hand.css({
						transform:'rotate('+((hours%12)*30)+'deg)'
					});
					break;
				case atp.status.MINUTES:
					pluginElements.current.minutes.addClass('selected');
					pluginElements.current.hours.removeClass('selected');
					pluginElements.clock.hand.css({
						transform:'rotate('+(minutes*6)+'deg)'
					});
	
			}
	
		};
	
		var observer=new atp.Observer(refreshView);
	
		atp.state.addObserver(observer);
	
		
		var start=function(){
			var element=this;
			var values=element.value.split(":");
			atp.state.setHours(parseInt(values[0])||0);
			atp.state.setMinutes(parseInt(values[1])||0);
			setAm(atp.state.getHours()<12);
			setStatus(atp.status.HOURS, true);
			alignPluginOn(element);
			pluginElements.main.css('display', 'block');
	
			(new Promise(function(resolve, reject){
				timePromise.resolve=resolve;
				timePromise.reject=reject;
			}))
			.then(function(value){
				element.value=value;
				dismiss();
			})
			.catch(function(){
				dismiss();
			});
		};
	
		var dismiss=function(){
			pluginElements.main.css('display', 'none');
			setStatus(atp.status.HOURS);
		};
	
		
		var getStatus=function(){ return statusNow };
	
		
		var setStatus=function(status, immediate){
			if (statusNow==status)
				return;
			statusNow=status;
			transition(immediate);
		};
	
		var transition=function(immediate){
	
			var duration=immediate?0:150;
	
			switch (getStatus()){
				case atp.status.MINUTES:
					atp.animate({
						element:pluginElements.clock.hours,
						styles:{
							width:[100, 125, '%'],
							height:[100, 125, '%'],
							top:[0, -12.5, '%'],
							left:[0, -12.5, '%'],
							opacity:[1, 0, '']
						},
						easing: atp.animate.easing.flex,
						duration: duration,
						callback: function(){
							pluginElements.clock.hours.css('display', 'none');
							refreshView();
							atp.animate({
								element:pluginElements.clock.minutes.css('display', 'block'),
								styles:{
									height:[50, 100, '%'],
									width:[50, 100, '%'],
									left:[25, 0, '%'],
									top:[25, 0, '%'],
									opacity:[0, 1, '']
								},
								duration:duration
							});
						}
					});
					break;
				case atp.status.HOURS:
					atp.animate({
						element:pluginElements.clock.minutes,
						styles:{
							width:[100, 50, '%'],
							height:[100, 50, '%'],
							top:[0, 25, '%'],
							left:[0, 25, '%'],
							opacity:[1, 0, '']
						},
						easing: atp.animate.easing.flex,
						duration: duration,
						callback: function(){
							pluginElements.clock.minutes.css('display', 'none');
							refreshView();
							atp.animate({
								element:pluginElements.clock.hours.css('display', 'block'),
								styles:{
									height:[125, 100, '%'],
									width:[125, 100, '%'],
									left:[-12.5, 0, '%'],
									top:[-12.5, 0, '%'],
									opacity:[0, 1, '']
								},
								duration: duration
							});
						}
					});
			}
	
		};
	
		var offset=function(element){
	
		    var rect=element.getBoundingClientRect(),
		    	offsetTop=rect.top,
		    	offsetLeft=rect.left;
	
		    return {
		    	top: offsetTop,
		    	left: offsetLeft
		    };
		}
		
		var alignPluginOn=function(element){
			if (!pluginElements)
				return;
			var pos=offset(element);
			pos.top+="px";
			pos.left+="px";
			pluginElements.main.css(pos);
		};
	
		
		var bindToElement=function(element){
			pluginElements={
				main:        atp.ux.jQuery(element),
				current:{
					hours:   atp.ux.jQuery(element.querySelector('.atp-current-hours')),
					minutes: atp.ux.jQuery(element.querySelector('.atp-current-minutes')),
					ampm:    atp.ux.jQuery(element.querySelector('.atp-current-am-pm'))
				},
				clock:{
					hours:   atp.ux.jQuery(element.querySelector('.atp-hours')),
					minutes: atp.ux.jQuery(element.querySelector('.atp-minutes')),
					face:    atp.ux.jQuery(element.querySelector('.atp-cover')),
					hand:    atp.ux.jQuery(element.querySelector('.atp-hand'))
				},
				buttons:{
					am:      atp.ux.jQuery(element.querySelector('.atp-am-select')),
					pm:      atp.ux.jQuery(element.querySelector('.atp-pm-select')),
					ok:      atp.ux.jQuery(element.querySelector('.atp-button-ok')),
					cancel:  atp.ux.jQuery(element.querySelector('.atp-button-cancel'))
				}
			};
			pluginElements.clock.face.on("click mousedown mousemove mouseup touchstart touchend touchmove touchcancel", clockEventHandler);
			pluginElements.buttons.ok.on('click', function(){
				timePromise.resolve(
					formatNumber(atp.state.getHours())+":"+
					formatNumber(atp.state.getMinutes())
				);
			});
			pluginElements.buttons.cancel.on('click', function(){
				timePromise.reject();
			});
			pluginElements.buttons.am.on('click', function(){
				setAm(true);
			});
			pluginElements.buttons.pm.on('click', function(){
				setAm(false);
			});
			pluginElements.current.hours.on("click", function(){
				setStatus(atp.status.HOURS);
			});
			pluginElements.current.minutes.on("click", function(){
				setStatus(atp.status.MINUTES);
			});
	
		};
	
		var setAm=function(am){
	
			if (am && atp.state.getHours()>=12)
				atp.state.setHours(atp.state.getHours()-12);
			else if (!am && atp.state.getHours()<12)
				atp.state.setHours(atp.state.getHours()+12);
	
			isAm=am;
	
		};
	
		var clockEventHandler=function(e){
	
			var next;
			switch (e.type){
				case "mousedown":
				case "touchstart":
					tracking=true;touched=true;
					break;
				case "mouseup":
				case "touchend":
				case "touchcancel":
					tracking=false;
				case "click":
					next=true;
			}
			if (e.type.indexOf("touch")!=-1 && !next){
				e.preventDefault();
				e.pageX=e.originalEvent.touches[0].pageX;
				e.pageY=e.originalEvent.touches[0].pageY;
			}
			if (next && touched){
				if (getStatus()===atp.status.HOURS){
					setStatus(atp.status.MINUTES);
				}
			}
			if (!tracking)
				return;
	
			var parentOffset = offset(this);
			//var _this=atp.ux.jQuery(this);
	
			var x = ((e.pageX - parentOffset.left)/this.getBoundingClientRect().width-.5)*2;
			var y = ((e.pageY - parentOffset.top)/this.getBoundingClientRect().height-.5)*-2;
			var distanceFromOrigin=Math.sqrt(x*x+y*y);
			if (distanceFromOrigin<.5)
				return;
			var factor=1/distanceFromOrigin;
			x*=factor;
			y*=factor;
			var theta=Math.atan2(y, x);
			if (theta<0)
				theta+=Math.PI*2;
	
			switch (getStatus()){
				case atp.status.HOURS:
					atp.state.setHours(
						fromRadians(theta, 12)+(isAm?0:12)
					);
					break;
				case atp.status.MINUTES: 
					atp.state.setMinutes(
						fromRadians(theta, 60)
					);
					break;
			}
	
		};
	
		var fromRadians=function(theta, of){
	
			var n=of;
			var q1=new atp.Stack();
			var q234=new atp.Stack();
			for (var i=0; i<n; i++){
				if (i/n<=.25)
					q1.push(i);
				else
					q234.push(i);
			}
			var order=[];
			while (!q1.isEmpty())
				order.push(q1.pop());
			while (!q234.isEmpty())
				order.push(q234.pop());
	
			var index=Math.round( (theta/(2*Math.PI)) * n );
	
			if (index==n)
				index=0;
	
			return order[index];
	
		};
	
		var formatNumber=function(n){
			return (n<10)?'0'+n:n;
		};
	
		atp.ux={
			'start':start
		};
	
	})(atp);
	
	angular.module("ngAtp", []).directive("ngAtp", ['$compile', function($compile){
	
		atp.ux.jQuery=angular.element;
	
	
	
		return function(scope, element, attrs){
		  if (Modernizr.inputtypes.time && isMobileOs()) {
	      const date = scope.quote.dates[0] ? scope.quote.dates[0] : new Date()
	      var html = element
	                  .clone()
	                  .removeAttr('ng-click data-ng-atp ng-value')
	                  .attr('type','time')
	                  .attr('ng-value', "(quote.dates[0] | date:'HH:mm':'+0000')")
	                  [0].outerHTML 
	      var replace = $compile(html)(scope)
	      element.replaceWith(replace)
	      replace.on('input', function() {
	        var newdate = moment(scope.dates[0]).startOf('day').add(this.valueAsNumber,'ms')
	        scope.dates[0] = newdate.toDate()
	      })
	      return
	    }
	    $('body').on('click', '.atp-button-ok', function() {
	      scope.$apply(function($scope) {
	        if (!$scope.dates) return;
	        var date = new Date($scope.dates[0])
	        date.setUTCMinutes(atp.state.getMinutes())
	        date.setUTCHours(atp.state.getHours());
	        $scope.dates[0] = date
	      })
	    })
			element.bind("focus", atp.ux.start);
		};
	}]);


/***/ },
/* 12 */
/***/ function(module, exports) {

	(function ($) {
	  $.fn.mySlidePlugin = function (interval, space) {
	    var conteiner = this;
	
	    var width_to_move = ($($(conteiner).children().first()[0]).width() + space) * interval;
	
	
	    $(conteiner).parent().append('<div class="btnWrap">' +
	      '<button class="rightBtn"></button>' +
	      '<button class="leftBtn"></button>' +
	      '</div>');
	
	    $(conteiner).parent().find('.leftBtn').css('display', 'none');
	    var pos = 0;
	
	    window.addEventListener("resize", function() {
	      pos=0;
	      $(conteiner).css("margin-left", pos);
	      width_to_move = ($($(conteiner).children().first()[0]).width() + space) * interval;
	    }, false);
	    $(conteiner).parent().find('.rightBtn').click(function () {
	      $(conteiner).parent().find('.leftBtn').css("display", "block");
	      if ($(conteiner).children().last().offset().left > $(conteiner).parent().offset().left + $($(conteiner).parent()).width()) {
	        pos -= width_to_move;
	        $(conteiner).css("margin-left", pos)
	      }
	      else {
	        $(this).css("display", "none");
	      }
	    })
	    $(conteiner).parent().find('.leftBtn').click(function () {
	      $(conteiner).parent().find('.rightBtn').css("display", "block");
	      if (($(conteiner).children().first().offset().left + space) < $(conteiner).parent().offset().left) {
	        pos += width_to_move;
	        $(conteiner).css("margin-left", pos)
	      }
	      else {
	        $(this).css("display", "none");
	      }
	    })
	  }
	})(jQuery);
	/*--------------------------------------------------------------------------*/
	


/***/ },
/* 13 */
/***/ function(module, exports) {

	try {
	  var jsonlddata = JSON.parse(document.getElementById('jsonlddata').innerHTML);
	} catch (ex) {
	  var jsonlddata = [{ offers: [] }];
	}
	var blc_app = angular.module('blc', ['ngAtp']);
	// error on minification angular.module('blc').config('$sceProvider', ['$sceProvider', function( $sceProvider ) { $sceProvider.enabled(false); }] );
	angular.module('blc').filter('unsafe', ['$sce' ,function($sce) { return function(val) { return $sce.trustAsHtml(val); }; }]);
	angular.module('blc').constant('JSONLD', { hotoffers: jsonlddata[0].offers });
	angular.module('blc').constant('cars', (typeof prototypes=='undefined' ? [] : prototypes));
	
	angular.module('blc').service('redcontrol', function() {
	  this.popup = null
	  return this.popup;
	});
	angular.module('blc').service('search', ['$http', function($http) {
	  this.search = {
	    brands:[],
	    categories:[],
	    check_passenger:[],
	    price_asc: false,
	    car_weight: function(car) {
	      return order[car.id] || 50;
	    }
	  };
	  return this.search;
	}]);
	
	angular.module('blc').constant('available_languages', {en: 'English', ru: 'Русский', fr: 'Francais'});
	angular.module('blc').constant('phone_prefixes', [{iso: "AD","name": "Andorra",code: "376"}, {iso: "AE","name": "United Arab Emirates",code: "971"}, {iso: "AF","name": "Afghanistan",code: "93"}, {iso: "AG","name": "Antigua and Barbuda",code: "1268"}, {iso: "AI","name": "Anguilla",code: "1264"}, {iso: "AL","name": "Albania",code: "355"}, {iso: "AM","name": "Armenia",code: "374"}, {iso: "AN","name": "Netherlands Antilles",code: "599"}, {iso: "AO","name": "Angola",code: "244"}, {iso: "AQ","name": "Antarctica",code: "672"}, {iso: "AR","name": "Argentina",code: "54"}, {iso: "AS","name": "American Samoa",code: "1684"}, {iso: "AT","name": "Austria",code: "43"}, {iso: "AU","name": "Australia",code: "61"}, {iso: "AW","name": "Aruba",code: "297"}, {iso: "AZ","name": "Azerbaijan",code: "994"}, {iso: "BA","name": "Bosnia And Herzegovina",code: "387"}, {iso: "BB","name": "Barbados",code: "1246"}, {iso: "BD","name": "Bangladesh",code: "880"}, {iso: "BE","name": "Belgium",code: "32"}, {iso: "BF","name": "Burkina Faso",code: "226"}, {iso: "BG","name": "Bulgaria",code: "359"}, {iso: "BH","name": "Bahrain",code: "973"}, {iso: "BI","name": "Burundi",code: "257"}, {iso: "BJ","name": "Benin",code: "229"}, {iso: "BM","name": "Bermuda",code: "1441"}, {iso: "BN","name": "Brunei Darussalam",code: "673"}, {iso: "BO","name": "Bolivia",code: "591"}, {iso: "BR","name": "Brazil",code: "55"}, {iso: "BS","name": "Bahamas",code: "1242"}, {iso: "BT","name": "Bhutan",code: "975"}, {iso: "BW","name": "Botswana",code: "267"}, {iso: "BY","name": "Belarus",code: "375"}, {iso: "BZ","name": "Belize",code: "501"}, {iso: "CA","name": "Canada",code: "1  "}, {iso: "CD","name": "Democratic Republic Of Congo",code: "243"}, {iso: "CF","name": "Central African Republic",code: "236"}, {iso: "CG","name": "Congo",code: "242"}, {iso: "CH","name": "Switzerland",code: "41"}, {iso: "CI","name": "Cote D\'Ivoire",code: "225"}, {iso: "CK","name": "Cook Islands",code: "682"}, {iso: "CL","name": "Chile",code: "56"}, {iso: "CM","name": "Cameroon",code: "237"}, {iso: "CN","name": "China",code: "86"}, {iso: "CO","name": "Colombia",code: "57"}, {iso: "CR","name": "Costa Rica",code: "506"}, {iso: "CS","name": "Serbia",code: "381"}, {iso: "CU","name": "Cuba",code: "53"}, {iso: "CV","name": "Cape Verde",code: "238"}, {iso: "CY","name": "Cyprus",code: "357"}, {iso: "CZ","name": "Czech Republic",code: "420"}, {iso: "DE","name": "Germany",code: "49"}, {iso: "DJ","name": "Djibouti",code: "253"}, {iso: "DK","name": "Denmark",code: "45"}, {iso: "DM","name": "Dominica",code: "1767"}, {iso: "DO","name": "Dominican Republic",code: "1809"}, {iso: "DZ","name": "Algeria",code: "213"}, {iso: "EC","name": "Ecuador",code: "593"}, {iso: "EE","name": "Estonia",code: "372"}, {iso: "EG","name": "Egypt",code: "20"}, {iso: "ER","name": "Eritrea",code: "291"}, {iso: "ES","name": "Spain",code: "34"}, {iso: "ET","name": "Ethiopia",code: "251"}, {iso: "FI","name": "Finland",code: "358"}, {iso: "FJ","name": "Fiji",code: "679"}, {iso: "FK","name": "Falkland Islands",code: "500"}, {iso: "FM","name": "Micronesia",code: "691"}, {iso: "FO","name": "Faroe Islands",code: "298"}, {iso: "FR","name": "France",code: "33"}, {iso: "GA","name": "Gabon",code: "241"}, {iso: "GB","name": "United Kingdom",code: "44"}, {iso: "GD","name": "Grenada",code: "1473"}, {iso: "GE","name": "Georgia",code: "995"}, {iso: "GF","name": "French Guiana",code: "594"}, {iso: "GH","name": "Ghana",code: "233"}, {iso: "GI","name": "Gibraltar",code: "350"}, {iso: "GL","name": "Greenland",code: "299"}, {iso: "GM","name": "Gambia",code: "220"}, {iso: "GN","name": "Guinea",code: "224"}, {iso: "GP","name": "Guadeloupe",code: "590"}, {iso: "GQ","name": "Equatorial Guinea",code: "240"}, {iso: "GR","name": "Greece",code: "30"}, {iso: "GT","name": "Guatemala",code: "502"}, {iso: "GU","name": "Guam",code: "1671"}, {iso: "GW","name": "Guinea-Bissau",code: "245"}, {iso: "GY","name": "Guyana",code: "592"}, {iso: "HK","name": "Hong Kong",code: "852"}, {iso: "HN","name": "Honduras",code: "504"}, {iso: "HR","name": "Croatia",code: "385"}, {iso: "HT","name": "Haiti",code: "509"}, {iso: "HU","name": "Hungary",code: "36"}, {iso: "ID","name": "Indonesia",code: "62"}, {iso: "IE","name": "Ireland",code: "353"}, {iso: "IL","name": "Israel",code: "972"}, {iso: "IN","name": "India",code: "91"}, {iso: "IQ","name": "Iraq",code: "964"}, {iso: "IR","name": "Iran",code: "98"}, {iso: "IS","name": "Iceland",code: "354"}, {iso: "IT","name": "Italy",code: "39"}, {iso: "JM","name": "Jamaica",code: "1876"}, {iso: "JO","name": "Jordan",code: "962"}, {iso: "JP","name": "Japan",code: "81"}, {iso: "KE","name": "Kenya",code: "254"}, {iso: "KG","name": "Kyrgyzstan",code: "996"}, {iso: "KH","name": "Cambodia",code: "855"}, {iso: "KI","name": "Kiribati",code: "686"}, {iso: "KM","name": "Comoros",code: "269"}, {iso: "KN","name": "Saint Kitts and Nevis",code: "1869"}, {iso: "KP","name": "Korea",code: "850"}, {iso: "KR","name": "Korea",code: "82"}, {iso: "KW","name": "Kuwait",code: "965"}, {iso: "KY","name": "Cayman Islands",code: "1345"}, {iso: "KZ","name": "Kazakhstan",code: "7 "}, {iso: "LA","name": "Laos",code: "856"}, {iso: "LB","name": "Lebanon",code: "961"}, {iso: "LC","name": "Saint Lucia",code: "1758"}, {iso: "LK","name": "Sri Lanka",code: "94"}, {iso: "LR","name": "Liberia",code: "231"}, {iso: "LS","name": "Lesotho",code: "266"}, {iso: "LT","name": "Lithuania",code: "370"}, {iso: "LU","name": "Luxembourg",code: "352"}, {iso: "LV","name": "Latvia",code: "371"}, {iso: "LY","name": "Libya",code: "218"}, {iso: "MA","name": "Morocco",code: "212"}, {iso: "MC","name": "Monaco",code: "377"}, {iso: "MD","name": "Moldova",code: "373"}, {iso: "ME","name": "Montenegro",code: "382"}, {iso: "MG","name": "Madagascar",code: "261"}, {iso: "MH","name": "Marshall Islands",code: "692"}, {iso: "MK","name": "Macedonia",code: "389"}, {iso: "ML","name": "Mali",code: "223"}, {iso: "MM","name": "Myanmar",code: "95"}, {iso: "MN","name": "Mongolia",code: "976"}, {iso: "MO","name": "Macau",code: "853"}, {iso: "MP","name": "Northern Mariana Islands",code: "1670"}, {iso: "MQ","name": "Martinique",code: "596"}, {iso: "MR","name": "Mauritania",code: "222"}, {iso: "MS","name": "Montserrat",code: "1664"}, {iso: "MT","name": "Malta",code: "356"}, {iso: "MU","name": "Mauritius",code: "230"}, {iso: "MV","name": "Maldives",code: "960"}, {iso: "MW","name": "Malawi",code: "265"}, {iso: "MX","name": "Mexico",code: "52"}, {iso: "MY","name": "Malaysia",code: "60"}, {iso: "MZ","name": "Mozambique",code: "258"}, {iso: "NA","name": "Namibia",code: "264"}, {iso: "NC","name": "New Caledonia",code: "687"}, {iso: "NE","name": "Niger",code: "227"}, {iso: "NF","name": "Norfolk Island",code: "672"}, {iso: "NG","name": "Nigeria",code: "234"}, {iso: "NI","name": "Nicaragua",code: "505"}, {iso: "NL","name": "Netherlands",code: "31"}, {iso: "NO","name": "Norway",code: "47"}, {iso: "NP","name": "Nepal",code: "977"}, {iso: "NR","name": "Nauru",code: "674"}, {iso: "NU","name": "Niue",code: "683"}, {iso: "NZ","name": "New Zealand",code: "64"}, {iso: "OM","name": "Oman",code: "968"}, {iso: "PA","name": "Panama",code: "507"}, {iso: "PE","name": "Peru",code: "51"}, {iso: "PF","name": "French Polynesia",code: "689"}, {iso: "PG","name": "Papua New Guinea",code: "675"}, {iso: "PH","name": "Philippines",code: "63"}, {iso: "PK","name": "Pakistan",code: "92"}, {iso: "PL","name": "Poland",code: "48"}, {iso: "PM","name": "St. Pierre and Miquelon",code: "508"}, {iso: "PR","name": "Puerto Rico",code: "1 "}, {iso: "PS","name": "Palestine",code: "972"}, {iso: "PT","name": "Portugal",code: "351"}, {iso: "PW","name": "Palau",code: "680"}, {iso: "PY","name": "Paraguay",code: "595"}, {iso: "QA","name": "Qatar",code: "974"}, {iso: "RE","name": "Reunion",code: "262"}, {iso: "RO","name": "Romania",code: "40"}, {iso: "RS","name": "Serbia",code: "381"}, {iso: "RU","name": "Russia",code: "7"}, {iso: "RW","name": "Rwanda",code: "250"}, {iso: "SA","name": "Saudi Arabia",code: "966"}, {iso: "SB","name": "Solomon Islands",code: "677"}, {iso: "SC","name": "Seychelles",code: "248"}, {iso: "SD","name": "Sudan",code: "249"}, {iso: "SE","name": "Sweden",code: "46"}, {iso: "SG","name": "Singapore",code: "65"}, {iso: "SH","name": "St. Helena",code: "290"}, {iso: "SI","name": "Slovenia",code: "386"}, {iso: "SK","name": "Slovakia",code: "421"}, {iso: "SL","name": "Sierra Leone",code: "232"}, {iso: "SN","name": "Senegal",code: "221"}, {iso: "SO","name": "Somalia",code: "252"}, {iso: "SR","name": "Suriname",code: "597"}, {iso: "ST","name": "Sao Tome and Principe",code: "239"}, {iso: "SV","name": "El Salvador",code: "503"}, {iso: "SY","name": "Syria",code: "963"}, {iso: "SZ","name": "Swaziland",code: "268"}, {iso: "TC","name": "Turks and Caicos Islands",code: "1649"}, {iso: "TD","name": "Chad",code: "235"}, {iso: "TG","name": "Togo",code: "228"}, {iso: "TH","name": "Thailand",code: "66"}, {iso: "TJ","name": "Tajikistan",code: "992"}, {iso: "TM","name": "Turkmenistan",code: "993"}, {iso: "TN","name": "Tunisia",code: "216"}, {iso: "TO","name": "Tonga",code: "676"}, {iso: "TP","name": "East Timor-Indonesia",code: "62"}, {iso: "TR","name": "Turkey",code: "90"}, {iso: "TT","name": "Trinidad And Tobago",code: "1868"}, {iso: "TV","name": "Tuvalu",code: "688"}, {iso: "TW","name": "Taiwan",code: "886"}, {iso: "TZ","name": "Tanzania",code: "255"}, {iso: "UA","name": "Ukraine",code: "380"}, {iso: "UG","name": "Uganda",code: "256"}, {iso: "UK","name": "United Kingdom",code: "44"}, {iso: "US","name": "United States",code: "1"}, {iso: "UY","name": "Uruguay",code: "598"}, {iso: "UZ","name": "Uzbekistan",code: "998"}, {iso: "VC","name": "Saint Vincent and the Grenadin",code: "1784"}, {iso: "VE","name": "Venezuela",code: "58"}, {iso: "VG","name": "Virgin Islands",code: "1284"}, {iso: "VN","name": "Viet Nam",code: "84"}, {iso: "VU","name": "Vanuatu",code: "678"}, {iso: "VZ","name": "Venezuela",code: "58"}, {iso: "WF","name": "Wallis and Futuna Islands",code: "681"}, {iso: "WS","name": "Samoa",code: "685"}, {iso: "YE","name": "Yemen",code: "967"}, {iso: "YU","name": "Yugoslavia",code: "381"}, {iso: "ZA","name": "South Africa",code: "27"}, {iso: "ZM","name": "Zambia",code: "260"}, {iso: "ZR","name": "Zaire",code: "241"}, {iso: "ZW","name": "Zimbabwe",code: "263"}]);


/***/ },
/* 14 */
/***/ function(module, exports) {

	/*
	var animNav = function () {
	  $('.animNav .number').text(jsonlddata[0].offers.length || '');
	  var footer_track = function () {
	    if (typeof this.set_footer_timeout=='undefined') this.set_footer_timeout = null;
	    if (typeof this.nav=='undefined') this.nav = $('.animNav');
	    var footer = $('body>footer').position().top + 100,
	        scrollpos = scrol.pos() + $(window).height(),
	        navpos = this.nav.offset().top;
	    if (scrollpos > footer) {
	      this.nav.removeClass('active').addClass('footer').css('margin-bottom', scrollpos-footer); 
	    } else {
	      if (this.nav.hasClass('footer')) {
	        if (footer-scrollpos<90) this.nav.css('margin-bottom', scrollpos-footer);
	        else {
	          this.nav.removeClass('footer').css('margin-bottom' , 0);
	          this.nav.prepend(this.nav.find('ul'));
	        }
	      }
	    }
	  }
	  $(window).on("scroll fake_scroll", footer_track);
	
	  $('.animNav section').prepend($('<b class=close>').click(function() { $('body').click(); }));
	  $('.animNav').click(function(e) {
	    e.stopPropagation();
	  });
	
	  if (jsonlddata[0].offers.length>0) {
	    $('.animNav li.spec').click(function() {
	      $('.animNav').toggleClass('pop ho');
	    });
	  }
	
	  $('.animNav li.cross').click(function () {
	    $('.animNav').toggleClass("active");
	  });
	  $('.animNav li.recent').click(function() {
	    $('.animNav').toggleClass('pop recent');
	  });
	  $("body").click(function() {
	    $('.animNav').removeClass('pop ho recent');
	  });
	  $('.animNav li.phone').click( show_quote_form );
	  $('.animNav li').click( function() { ga('send','event','green','click', this.className); } );
	}
	$(document).ready(animNav);
	*/


/***/ },
/* 15 */
/***/ function(module, exports) {

	angular.module('blc').factory('browser', browser);
	browser.$inject = ['$q', '$log', '$http'];
	function browser($q, $log, $http) {
	  var promise = $http.get('/client-data');
	  return {
	    getData: promise
	  }
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	var Pikaday = __webpack_require__(2);
	
	angular.module('blc').directive('blcCalendar', blc_calendar_single);
	blc_calendar_single.$inject = ['$compile']
	function blc_calendar_single($compile) {
	  // may be var pixker is the same for all instances;
	  controller.$inject = ['$scope'];
	  return {
	    restrict: 'A',
	    scope: true,
	    link: link,
	    controller: controller
	  }
	  function controller($scope) {
	    return 
	    $scope.$watch('quote.dates', function(curr, old) {
	      // $scope.picker.setRangeStart(curr[0]);
	      // $scope.picker.setRangeEnd(curr[1]);
	      $scope.picker.draw(1);
	    }, 1);
	    $scope.$watch('current_date', function (curr, prev) {
	      if (curr===null) return;
	      $scope.picker.setMinDate(new Date( curr===0 ? null : $scope.quote.dates[0] ));
	      $scope.picker.draw(1);
	    });
	
	  }
	
	
	
	  function link($scope,elm,attrs) {
	
	
	    elm.addClass('blc-calendar');
		  if (Modernizr.inputtypes.date && isMobileOs()) {
	      const date = $scope.quote.dates[0] ? $scope.quote.dates[0] : new Date()
	      var html = elm
	                  .clone()
	                  .removeAttr('ng-click blc-calendar ng-value')
	                  .attr('type','date')
	                  .attr('ng-value', "(quote.dates[0] | date:'yyyy-MM-dd':'+0000')")
	                  [0].outerHTML 
	      var replace = $compile(html)($scope)
	      elm.replaceWith(replace)
	      replace.on('input', function() {
	        const olddate = moment($scope.quote.dates[0] ? $scope.quote.dates[0] : new Date)
	        var newdate = moment(this.valueAsNumber).startOf('day').hour(olddate.hour()).minute(olddate.minute())
	        $scope.quote.dates[0] = newdate.toDate()
	      })
	      return
	    }
	    $scope.picker = new Pikaday({
	      numberOfMonths: isMobile() ? 18 : 2,
	      minDate: new Date(),
	      onOpen:function(){
	      },
	      onSelect: function (evt) {
	        var d = this._d;
	        $scope.$apply(function() {
	          $scope.quote.dates[$scope.current_date] = d;
	          $scope.dates = $scope.quote.dates;
	
	          // $scope.picker.draw(1);
	        });
	      }
	    });
	    elm.after($scope.picker.el);
	  }
	
	}


/***/ },
/* 17 */
/***/ function(module, exports) {

	angular.module('blc').directive('googleplace', google_place_directive)
	function google_place_directive() {
	  return {
	    //require: 'ngModel',
	    scope: {
	      place:   '=googleplace',
	      country: '=',
	      ngModel: '=',
	      index:   '=?',
	      details: '=?'
	    },
	    link: link
	  }
	  function link(scope, element, attrs, model) {
	    scope.$watch('place', function(curr, prev) { if (curr!==prev) element.val(curr); });
	    element.val(scope.place);
	    var country;
	    var index= scope.index || 0;
	    var that = scope;
	    var options = {
	      types: [],
	      componentRestrictions: {}
	    };
	    var quote = scope.$parent.quote;
	    scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
	
	    element.on('input', reset_error  );
	    element.on('blur',   update_scope );
	    google.maps.event.addListener(scope.gPlace, 'place_changed', function() { element.blur(); });
	    function update_scope() {
	      reset_error();
	      var geoComponents = scope.gPlace.getPlace();
	      if (!geoComponents) {
	        // seems empty
	        scope.$apply(function() {
	          scope.place = ''
	        })
	        return;
	      }
	      var addressComponents = geoComponents.address_components;
	      addressComponents = addressComponents.filter(function(component){
	        switch (component.types[0]) {
	          case "locality": // city
	            return true;
	          case "administrative_area_level_1": // state
	            return true;
	          case "country": // country
	            country = component.short_name;
	            return true;
	          default:
	            return false;
	        }
	      }).map(function(obj) {
	        return obj.long_name;
	      });
	
	      scope.$apply( function() {
	        scope.details = addressComponents; // array containing each location component
	        quote.geo[index] = geoComponents.geometry.location.toJSON();
	        if (quote.country_valid(country)) {
	          scope.country = country;
	          scope.place = element.val();
	        } else {
	          scope.$emit('error', element);
	          scope.place = '';
	        }
	      });
	    }
	    function reset_error() { 
	      scope.$emit('error',  null); 
	    } 
	  }
	}


/***/ },
/* 18 */
/***/ function(module, exports) {

	angular.module('blc').factory('xlat_service', xlat_srv);
	xlat_srv.$inject = ['browser'];
	function xlat_srv(browser) {
	  var current_lang = 'en';
	  // var tables = $.extend(true, {}, initial_xlat_tables);
	  var tables = {}
	  browser.getData.then(function(data) {
	    tables = data.data.i18;
	  });
	  
	  return {
	    set_lang: function(lang) { 
	      current_lang = lang;
	    },
	    get_lang: function() { return current_lang; },
	    xlat: xlat
	  }
	  function xlat(label, params) {
	    if (typeof tables=='undefined' || current_lang=='en' || typeof tables[current_lang]=='undefined') return label;
	    return tables[current_lang][label] || label;
	  }
	}
	
	angular.module('blc').filter('xlat', ['xlat_service', function(xlat_service) {
	  function filterFn(label,params) {
	    return xlat_service.xlat(label, params);
	  }
	  filterFn.$stateful = true;
	  return filterFn;
	}]);
	
	angular.module('blc').directive('blcI18', i18_directive);
	i18_directive.$inject = ['xlat_service']
	function i18_directive(xlat_service) {
	  return {
	    restrict: 'A',
	    controller: ['$scope','$element', function($scope, $element) {
	      $scope.$watch(function() { return xlat_service.get_lang(); }, function(curr, prev) {
	        if (curr==prev) return ;
	        var tr = xlat_service.xlat($element.text());
	        $element.html(tr);
	      });
	    }]
	  }
	}


/***/ },
/* 19 */
/***/ function(module, exports) {

	angular.module('blc').factory('currency_srv', currency_srv);
	currency_srv.$inject = ['browser'];
	function currency_srv(browser) {
	  var rates = {'EUR': 1, USD: 1},
	      glyphs = { EUR: '€',USD: '$', GBP: '£', CHF: 'CHF' }
	      current_code = 'EUR';
	
	  browser.getData.then(function(data) {
	    rates = data.data.rates;
	  });
	  return {
	    set_currency: function(code) { 
	      current_code = code; 
	    },
	    get_currency: function() { 
	      return { code: current_code, rate: rates[current_code],sym: glyphs[current_code]}  
	    },
	  }
	}
	
	
	angular.module('blc').filter('currency', ['currency_srv', function(currency_srv) {
	  return function(input) {
	    var curr = currency_srv.get_currency();
	    return "<sup>" + curr.sym + "</sup>" + input * curr.rate ;
	  }
	}])


/***/ },
/* 20 */
/***/ function(module, exports) {

	angular.module('blc').service('quote', quote_service);
	quote_service.$inject = ['$interval','$http','$rootScope'];
	function quote_service($interval,$http, $rootScope) {
	  var that = this;
	  this.quote = {
	    id:               null,
	    dates:            [],
	    places:           [],
	    geo:              [],
	    countries:        [],
	    atype:            0,
	    car:              null,
	    service:          {},
	    status:           1,
	    agree2news:       true,
	    personal:         { name:    null, phone:   null, email:   null, message: null },
	// --------------------------------------------------------------------------------------
	    recent_cars:      recent_cars,
	    country_valid:    country_valid,
	    places_formatted: places_formatted,
	    reset:            reset,
	    submit_quote:     submit_quote,
	    update:           save_me,
	    goto_search:      goto_search,
	    days:             function() { return Math.ceil(this.hours() / 24) },
	    hours:            hours,
	// --------------------------------------------------------------------------------------
	    clear_car:        function() { this.car = null; this.car_id = null; },
	    ready:            function() { return this.dates.join('').length>0 && this.places.join('').length>0; },
	    url:              function() { return '/search?param_id=' + this.id; },
	  };
	  this.old_hash = 0; 
	  if (ho=location.search.match(/offer=(\w+)/)) {
	    this.quote.offer = ho[1];
	  }
	  var storage_quote = localStorage.getObject('quote');
	  if (storage_quote) {
	    $.extend(this.quote, storage_quote);
	    ga('send','event','quote','restore from localStorage',this.quote.id||'noID')
	  }
	  if (!this.quote.service.landing_page) {
	    if (typeof sessionStorage.landing_page==='undefined') {
	      sessionStorage.landing_page = location.href;
	    }
	    this.quote.service.landing_page = sessionStorage.landing_page;
	  }
	
	  if (jsonlddata[1]) { // set quote car from car page
	    this.quote.car = {
	      id: jsonlddata[1].productID,
	      title: jsonlddata[1].name,
	      price: jsonlddata[1].offers.price,
	      prototype: jsonlddata[1]['@id'],
	      image: jsonlddata[1].image
	    }      
	  }
	  $interval(save_me, 1000);
	
	  return this.quote;
	
	  // ------------------------------
	  function hours() {
	    var daystart   = that.quote.dates[0] || that.quote.dates[1],
	        dayend     = that.quote.dates[1] || that.quote.dates[0],
	        hours      = moment(dayend).diff(moment(daystart), 'hours');
	
	    return hours > 0 ? hours : 1;
	  }
	
	  function goto_search() {
	    var valid = validate();
	    if (valid===true) {
	      location.href = this.url();
	      ga('send','event','quote','init search',quote_short(), that.quote.id);
	      return true;
	    } else {
	      $rootScope.$broadcast('generic quote error');
	      ga('send','event','quote','error','attempt to search without all data');
	      return false; 
	    }
	  }
	
	  function places_formatted() {
	    var pl1 = that.quote.places[0],
	        pl2 = that.quote.places[1];
	    return [
	      typeof pl1=='object' ? ( pl1===null ? '' : pl1.name ) : pl1,
	      typeof pl2=='object' ? ( pl2===null ? '' : pl2.name ) : pl2
	    ];
	  }
	  function reset() {
	    if (that.quote.status==1) return;
	    that.quote.status = 1;
	    that.quote.agree2news = false;
	    that.quote.dates = [];
	    that.quote.places = [];
	
	    that.quote.car = null;
	    that.quote.id = null;
	  }
	
	  function submit_quote() {
	    ga('send', 'event','quote','new',quote_short(), that.quote.id);
	    that.quote.status = 2;
	    save_me();
	
	
	    setTimeout(function() { that.quote.reset() }, 2000);
	
	    $.magnificPopup.open({
	      mainClass: 'mfp-fade',
	      removalDelay: 400,
	      overflowY: 'scroll',
	      callbacks: {
	        afterClose: function() { 
	          // this not fire
	          ga('send', 'event', 'thank', 'close', quote_short(), that.quote.id);
	          setTimeout(function() {location.href = '/bspoke';}, 100);
	        },
	      },
	      items: [
	        {
	          type: 'inline',
	          src: '#thank'
	        }
	      ]
	    })
	
	    $('#thank .wp').addClass('insearch');
	    setTimeout(function(){
	      $('#thank .wp').removeClass('insearch');
	    }, 2000)
	    // isMobile() ? window.scrollTo(0, $('#thank').offset().top + 5) : 0;
	  }
	
	  function validate() {
	    var errors = [];
	    if (that.quote.places.join('').length===0) errors.push('places-empty');
	    if (that.quote.dates.join('').length===0) errors.push('dates-empty');
	    return errors.length>0 ? errors : true;
	  }
	  function country_valid(country) {
	    return true;
	    var allowedCountries = 'GB ES DE ES FR PT MC CH LI LU NL BE AT CZ AE IT HU'.toLowerCase().split(' ');
	    return allowedCountries.indexOf(country.toLowerCase())>=0;
	  }
	
	  function save_me() {
	    var new_hash = Hashcode.value(that.quote);
	    if (that.old_hash == new_hash) return;
	    that.old_hash = new_hash;
	    localStorage.setObject('quote', that.quote);
	
	    if (!that.quote.ready()) return;
	
	    if (that.quote.id) {
	      $http.patch('/quotes/' + that.quote.id, that.quote).success(function(data, status) {
	       // may be it is not needed 
	       $.extend(that.quote, data);
	      });
	      ga('send', 'event', 'quote', 'update', quote_short(),  that.quote.id );
	    } else {
	      $http.post('/quotes', that.quote).success(function(data, status) {
	        $.extend(that.quote, data); // update quote in controller
	        ga('send', 'event', 'quote', 'init', quote_short(),  that.quote.id );
	      });
	    }
	  }
	  function quote_short() {
	    var pl = that.quote.places_formatted().join(':');
	    var da = that.quote.dates.join(':');
	    return pl+" / "+da;
	  }
	  function recent_cars(ncars) {
	    if (!that.quote.id || !ncars) return [];
	    return $http.get('/quotes/'+that.quote.id+'/cars/' + ncars);
	  }
	}
	
	angular.module('blc').factory('prepare_quote', [ function() {
	  var prepare_quote = {
	    request: function(config) {
	      if (config.url.match(/quote/)) {
	        if (!config.data) return config;
	        if (config.updating_quote) return config;
	        if (typeof config.data.places[0] != 'undefined') {
	          config.data.places[0] = typeof config.data.places[0] == 'object' ? config.data.places[0].name : config.data.places[0];
	        }
	        var pl2 = config.data.places[1];
	        if (pl2 && typeof pl2 != 'undefined') {
	          config.data.places[1] = typeof pl2 == 'object' ? pl2.name : pl2;
	        }
	        if (typeof config.data.car != 'undefined' && config.data.car != null) {
	          config.data.car_id = typeof config.data.car == 'object' ? config.data.car.id : config.data.car;
	        }
	        config.data.atype = parseInt(config.data.atype);
	        //delete(config.data.car);
	        config.updating_quote = true;
	      }
	      return config;
	    },
	    response: function(response) {
	      if (response.config.url.match(/quote/)) {
	        if (response.config.updating_quote) {
	          delete(response.config.updating_quote);
	        }
	      }
	      return response;
	    }
	  };
	  return prepare_quote;
	}]);
	
	angular.module('blc').config(['$httpProvider', function($httpProvider) { 
	  $httpProvider.interceptors.push('prepare_quote'); 
	}]);
	


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	angular.module('blc').directive('redControl', directive);
	directive.$inject = ['quote','redcontrol'];
	function directive(quote, redcontrol) {
	  return {
	    restrict:    'A',
	    replace:     true,
	    templateUrl: '/red-control.html',
	    link: link,
	    controller: ['$scope', '$element', function($scope, $element) {
	      $scope.redcontrol = redcontrol
	    }],
	  }
	  function link($scope, $element) {
	    $element.on('click', 'li', function(evt) {
	      redcontrol.popup = this.getAttribute('data-popup')
	    })
	    $('body').on('click keyup', function(evt) {
	      if (evt.keyCode===27) redcontrol.popup=null
	      if ($(evt.target).closest('.animNav').length>0) return;
	      redcontrol.popup=null
	    })
	  }
	}


/***/ },
/* 22 */
/***/ function(module, exports) {

	angular.module('blc').directive('searchForm', search_form_dir);
	search_form_dir.$inject = ['quote', '$timeout', '$rootScope', '$sce'];
	function search_form_dir(quote, $timeout, $rootScope, $sce) {
	  var error = null;
	  if (isMobile()) {
	    $('body').on('focus', '.search-form .dates [type=button]', function() { this.click(); });
	
	    var listener = function () {
	      $('body').trigger('click');
	      $('.dates input').trigger('blur');
	    }
	    window.addEventListener('popstate', listener, false);
	  }
	  return {
	    replace: true,
	    scope: true,
	    restrict: 'A',
	    templateUrl: '/search-form-template.html',
	    link: link,
	    controller: ['$scope','$element', controller],
	  }
	  function link(scope, element, params) {
	  }
	  function controller($scope, $element) {
	   // $scope.currtab     = quote.atype;
	    $scope.quote       = quote;
	    $scope.places      = quote.places;
	    $scope.geo         = quote.geo;
	    $scope.rentalhours = quote.hours();
	    $scope.rentaldays  = quote.days();
	    $scope.dates       = quote.dates;
	    $scope.error       = error;
	    $scope.$watch('[rentaldays,rentalhours]', watch_hours);
	    $scope.$watch('currtab', reset_hours_days);
	    $rootScope.$on('generic quote error', show_generic_error);
	    var that = $scope;
	    that.current_date = null;
	    $('body').on('click', function (event) {
	      if ($(event.target).closest('.dates').length > 0) return;
	      that.$apply(function($scope) { $scope.current_date = null; });
	    })
	
	    that.goto_search = function() {
	      if (quote.ready()) {
	        quote.goto_search();
	      } else {
	        show_generic_error();
	      }
	    }
	    that.$on('error', error_watcher);
	    // that.$watch('dates', dates_watcher, 1);
	    that.$watch('current_date', function (curr, prev) {
	      if(isMobile()){
	        if (prev == curr) return; // init
	        if (prev == null && curr !== null) {
	          // add to history
	          if (typeof history.pushState != 'undefined') {
	            $(window).scrollTop($('.dates').offset().top - 20);
	            history.pushState({popup: '.dates'}, null, null);
	          }
	
	          window.setTimeout(function(){
	            var lendar_of_selected = $(picker.el).find('.range-start').closest('.pika-lendar');
	            lendar_of_selected.length > 0 ? $(window).scrollTop(lendar_of_selected.offset().top - 37 ) : $(window).scrollTop($(picker.el).offset().top - 37);
	          },0)
	          $('.dates input').on('blur', function () {     //need to disable jumping after change to back state
	            $(window).scrollTop($('.dates').offset().top - 20);
	          })
	        }
	      }
	      if (curr === 0) {
	        picker.setMinDate(new Date());
	        picker.draw();
	        isMobile()? $('.img_wrap img').css('transition','none'):0;
	      } else if (curr === 1) {
	        picker.setMinDate(that.dates[0]);
	        picker.draw();
	        isMobile()? $('.img_wrap img').css('transition','none'):0;
	      } else {
	        $('.img_wrap img').css('transition','opacity 1s');
	      }
	
	    });
	    function watch_hours(curr,prev) {
	      var d = moment($scope.dates[0]);
	      switch (quote.atype) {
	        case 2:
	          d.add(curr[0],'days');
	          break;
	        case 1:
	          d.add(curr[1],'hours');
	          break;
	      }
	
	      $scope.quote.dates[1] = d.toDate();
	    }
	    function reset_hours_days(curr, prev) {
	      switch (curr) {
	        case '0':
	          $scope.dates[1] = null;
	          break;
	        default:
	          $scope.places[1] = null;
	          watch_hours([ $scope.rentaldays, $scope.rentalhours ])
	      }
	    }
	
	    function dates_watcher(curr, prev) {
	      if (curr === prev) return; // init
	
	      if (that.current_date==0) { // start date selected
	        picker.setMinDate(curr[0]);
	        picker.setRangeStart(curr[0]);
	        if (curr[1] && curr[1]<curr[0]) {
	          curr[1] = new Date(curr[0]);
	          curr[1].setDate(curr[1].getDate() + 3);
	        }
	        that.current_date = null; //isMobile() ? null : 1;
	      } else if (that.current_date==1) { // end date selected
	        picker.setRangeEnd(curr[1]);
	        that.current_date = null;
	      }
	      picker.draw();
	    }
	    function error_watcher(evt, elm) {
	      if (elm===null) {
	        that.error_message = null;
	        return;
	      }
	      if (elm.attr('googleplace') ) {
	        that.error_message = $sce.trustAsHtml("We Are Always Expanding.<br>Unfortunately, <b>we don't service <u>" + elm.val() + "</u></b> at the moment.<br>Please search within Europe or UAE.");
	        elm.after($element.find('.search_error'));
	        ga('send','event','search','error location',elm.val());
	      }
	      if (elm=='general') {
	        that.error_message = "We Need Your Exact Pickup Location<br>We deliver your car wherever you want it.<br>Please choose an exact location from our search options.";
	        $element.find('[googleplace]:first').after($element.find('.search_error'));
	      }
	    }
	    function show_generic_error() {
	      that.error_message = $sce.trustAsHtml("We Need Your Exact Pickup Location<br>We deliver your car wherever you want it.<br>Please choose an exact location from our search options.");
	      var elm = $element.find('[googleplace]:first');
	      elm.after($element.find('.search_error'));
	    }
	  }
	}


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	
	angular.module('blc').directive('quoteForm',quoteformdir)
	quoteformdir.$inject = ['phone_prefixes', 'available_languages', 'browser','quote'];
	function quoteformdir(phone_prefixes, available_languages, browser, quote) {
	  $('body').on('change', '#choose_country', function () {
	    var elm = $(this).find('option:selected');
	    var ext = $(elm).data('phone');
	    elm.text(' (+' + ext + ')');
	    $(this).next('[type=tel]').focus();
	  });
	  return {
	    transclude:  true,
	    restrict:    'E',
	    replace:     true,
	    templateUrl: '/quote-form.html',
	    scope: {
	      car:   '=?car',
	      hide:  '@'
	    },
	    controller: ['$scope','$element', function($scope, $element) {
	      if ($scope.hide) $element.addClass('mfp-hide');
	      if (!$scope.quote) $scope.quote = quote;
	      if (!$scope.car)   $scope.car   = $scope.quote.car;
	
	      $scope.phone_prefixes = phone_prefixes;
	      $scope.available_languages = available_languages;
	      $scope.current_date = null;
	
	      if ($scope.quote.popupcar) show_quote_form();
	      
	      browser.getData.then(function(data) {
	        $scope.client_data = data.data;
	        if (!$scope.quote.personal.phone_prefix) {
	          var found_country = $scope.phone_prefixes.find_by_prop('iso', data.data.country_code);
	          if (found_country) {
	            $scope.quote.personal.phone_prefix = found_country.code;
	          }
	        }
	        setTimeout(function() { $('select', $element).trigger('change'); }, 500); // set phone prefix
	      });
	        
	      $scope.phone_prefix_code = function() { 
	        var found_region = phone_prefixes.find_by_prop("code", $scope.quote.personal.phone_prefix); 
	        return found_region ? found_region.iso.toLowerCase() : null; 
	      };
	    }],
	  };
	}
	


/***/ },
/* 24 */
/***/ function(module, exports) {

	angular.module('blc').controller('filter_popup', filter_popup_ctrl);
	filter_popup_ctrl.$inject = ['$scope', 'search', 'quote'];
	function filter_popup_ctrl($scope, search, quote) {
	  $scope.check_passenger = [999,999,999,999];
	  $scope.check_bag = [];
	  $scope.search = search;
	
	  $scope.update_search = function () {
	    search.check_passenger = $scope.check_passenger;
	  }
	  $scope.update_search();
	  $scope.$watch(function() { return $scope.check_passenger.join(); }, $scope.update_search)
	}
	


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1)
	
	angular.module('blc').controller('FooterCtrl', FooterCtrl);
	FooterCtrl.$inject = ['$scope', 'xlat_service', 'currency_srv'];
	function FooterCtrl($scope, xlat_service, currency_srv) {
	  $scope.language = xlat_service.get_lang();
	  $scope.currency_code = currency_srv.get_currency().code;
	
	
	  $scope.$watch('currency_code', function(curr, prev) {
	    if (curr==prev) return;
	    currency_srv.set_currency(curr);
	  });
	
	  $scope.$watch('language', function(curr, prev) {
	    if (curr==prev) return;
	    xlat_service.set_lang(curr);
	    $('#same-search').focus();  
	  });
	}
	


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	angular.module('blc').controller('CarsListCtrl', CarsListCtrl);
	CarsListCtrl.$inject = ['$scope', 'quote'];
	function CarsListCtrl($scope, quote) {
	  $scope.quote=quote;
	  $('.carlist').on('click', '.check', function(e) {
	    var li = $(this).closest('li')
	    var car = {
	      id: li.data('car-name'),
	      listing_image: { image: li.find('img').attr('src') },
	      price: li.data('car-price'),
	      title: li.find('h3').text()
	    }
	  $scope.$apply(function($scope) {
	    $scope.quote.car = car;
	    $scope.quote.popupcar = true;
	    // quote.update();
	    if(isMobile()){
	      show_quote_form();
	    } else {
	      scroll_to_search_form(function() {
	        //         $('.search-block > button').trigger('click');
	      })
	    }
	  })
	  });
	}


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	var Pikaday = __webpack_require__(2);
	
	angular.module('blc').controller('search_ctrl', search_ctrl);
	search_ctrl.$inject = ['$scope', '$element', '$compile', 'search', 'cars', 'quote', 'currency_srv'];
	function search_ctrl($scope, $element, $compile,  search, cars, quote, currency_srv) {
	  $scope.element = $element;
	  $scope.cars = cars;
	  $scope.search = search.search;
	  $scope.quote = quote;
	  $scope.selected_car = cars.find_by_prop('prototype_id', quote.car_id) || null;
	  $scope.quote = quote;
	  $scope.cars_limit = 4;
	  $scope.quote = quote;
	  $scope.search = search;
	  $scope.order_car = function (car) { return parseInt(car.rank_c); }
	  $scope.current_date = null;
	  $scope.categories_add = [];
	  $scope.brand_add = [];
	  $scope.page_tilte = "Availability results";
	
	  
	  $scope.currency = currency_srv;
	
	  $scope.$watch('search.price_asc', update_cars);
	  $scope.$watch('selected_car',      watch_selected_car, 1);// show 2.5 car info popup
	
	  $scope.filter_fit = function(car) {
	    return Math.random() > .7;
	  }
	  $scope.filter_add = function(car) {
	    var weight=0;
	    car.categories_ordered.forEach(function(index){
	      if(!index.brand) {
	        weight += ($scope.categories_add[index.name] || 0);
	      }
	      else {
	        weight += ($scope.brand_add[index.name] || 0);
	      }
	    })
	
	    if( search.check_passenger[0] != 999 && car.seats == 2) { weight += 1000; }
	    if( search.check_passenger[1] != 999 && car.seats == 4) { weight += 1000; }
	    if( search.check_passenger[1] != 999 && car.seats >  4) { weight += 100;  }
	    if( search.check_passenger[2] != 999 && car.seats == 5) { weight += 1000; }
	    if( search.check_passenger[2] != 999 && car.seats >  5) { weight += 100;  }
	    // if( search.check_passenger[3] != 999 && car.seats >= 7) { weight += 1000; }
	
	
	    return weight;
	
	    if(search.price_asc){
	      weight -= car.price;
	    }
	    else {
	      weight += car.price;
	    }
	
	  }
	  $scope.remove_tag = function ($event) {
	    delete(search.brands[$($event.target).text()]);
	    delete(search.categories[$($event.target).text()]);
	    delete($scope.search.brands[$($event.target).text()]);
	    delete($scope.search.categories[$($event.target).text()]);
	  }
	
	  $scope.quote_this_car = function() {
	    quote.car = this.car;
	    show_quote_form();
	  }
	
	  $scope.toggle_edit_search = function() {
	    $scope.element.find('.search-info').toggleClass('edit');    
	  }
	  function update_categories_ranks(curr,old){
	    $scope.categories_add = {};
	    Object.keys($scope.search.categories).forEach(function(cat) {
	      $scope.categories_add[cat] = 100000;
	    })
	    update_cars();
	  }
	  
	  $scope.cars_for_chemodans = function(n) {
	    var count = 0, i=0;
	    for (i;i<$scope.cars.length;i++) {
	      if ($scope.cars[i].chemodans>=n) count++;
	    }
	    return count;
	  }
	  $scope.cars_for_passengers = function(n) {
	    var count = 0, i=0;
	    for (i;i<$scope.cars.length;i++) {
	      if ($scope.cars[i].seats>=n) count++;
	    }
	    return count;
	  }
	
	  function update_brands_ranks(curr, old){
	    $scope.brand_add = {};
	    Object.keys($scope.search.brands).forEach(function(brd) {
	      $scope.brand_add[brd] = 100000;
	    })
	    update_cars();
	  }
	
	  function update_cars() {
	    var i, car, ncars = $scope.cars.length;
	    for (i=1;i<ncars;i++) {
	      car = $scope.cars[i];
	      car.rank_c = search.car_weight(car) + $scope.filter_add(car);
	    }
	    $scope.cars.sort(function(a,b) {
	      return a.rank_c > b.rank_c ? -1 : 1;
	    });
	    setTimeout(move_separator, 100);
	  }
	
	  function move_separator() {
	    var i, diff = 0, car, ncars = $scope.cars.length, car_id = 42;
	    var prev_rank = $scope.cars[0].rank_c;
	    for (i=1;i<ncars;i++) {
	      diff = $scope.cars[i].rank_c - prev_rank;
	      if (Math.abs(diff)>200) {
	        prev_rank = $scope.cars[i].rank_c;
	        car_id = i - 1;
	      }
	    }
	    var last_car = $scope.element.find('.stage_two_car_block:eq(' + car_id + ')');
	    last_car.after($scope.element.find('.separator'));
	  }
	  
	  function watch_selected_car(curr, old) {
	    if (curr==old) return ; // init
	    if (!curr) { $.magnificPopup.close(1); return; }
	    quote.car = curr;
	
	    if (isMobile()) {
	      location.href = '/' + curr.path;
	      return;
	    }
	
	    $.magnificPopup.open({
	      mainClass: 'mfp-fade',
	      removalDelay: 400,
	      overflowY: 'scroll',
	      callbacks: {
	        open: function() {
	
	        },
	        close: function(force) {
	          if (force) return ;
	          $scope.$apply(function() {
	            quote.clear_car();
	            $scope.selected_car = null;
	          })
	        }
	      },
	      items: [
	        {
	          type: 'inline',
	          src: '#car_info_popup'
	        }
	      ]
	    })
	  }
	  
	  var step_height = 800, next_step = 500;
	  window.addEventListener('scroll', function() {
	    if (!scrol.up() && window.scrollY>next_step) {
	      $scope.cars_limit += 4;
	      next_step += step_height;
	      setTimeout(function() { $(window).trigger('fake_scroll'); }, 1000);
	    }
	  });
	
	}
	
	


/***/ },
/* 28 */
/***/ function(module, exports) {

	angular.module('blc').controller('OffersCtrl', ['$scope', 'JSONLD', 'quote', function ($scope,JSONLD, quote) {
	  $scope.quote = quote;
	  $scope.offers = JSONLD.hotoffers;
	  $scope.quote_status = false;
	  $scope.$watch( function() { return quote.ready(); }, function(quote_status) { $scope.quote_ready = quote_status; });
	
	}]);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1);
	angular.module('blc').controller('RecentSearchController', RecentSearchController);
	RecentSearchController.$inject = ['$scope', '$element', '$http', '$rootScope', 'quote', 'currency_srv'];
	function RecentSearchController($scope, $element, $http, $rootScope, quote, currency_srv) {
	  $scope.quote        = quote;
	  $scope.quote_status = false;
	  $scope.currency     = currency_srv;
	  $scope.cars         = [];
	  $scope.goto_search  = goto_search;
	  $scope.length       = calculate_length;
	  var that            = $scope;
	  (function init() {
	    return
	    if (quote.id) {
	      quote.recent_cars(3).then(function(data) { 
	        $scope.cars = $.map(data.data, function(car) {
	          return {
	            name:        car.title,
	            price:       car.price,
	            image:       car.listing_image.image,
	            description: car.listing_text,
	            id:          car.id
	          };
	        });
	      });
	    } else {
	      // take 3 from list
	
	      $scope.cars = $.map($('ul.carlist li:lt(3)'), function(elm) {
	        return {
	          name:        $(elm).find('h3').text(),
	          price:       elm.getAttribute('data-car-price'),
	          image:       $(elm).find('img').attr('src'),
	          description: $(elm).find('p').text(),
	          id:          elm.getAttribute('data-car-name')
	        };
	      });
	
	      // car page : show current + first 2 from list
	      if (document.body.classList.contains('car_page')) {
	        var current_car = jsonlddata[1];
	        $scope.cars.unshift({
	          description: current_car.description,
	          price:       current_car.offers.price,
	          image:       current_car.image,
	          name:        current_car.name, 
	          id:          current_car['@id']
	        });
	      }
	    }
	  })();
	  $rootScope.$on('generic quote error', function() { $element.parent().removeClass('recent'); });
	  function calculate_length() {
	    if (!$scope.quote.dates[1]) return null;
	    var hours = moment($scope.quote.dates[1]).diff(moment($scope.quote.dates[0]), 'hours');
	    var days  = moment($scope.quote.dates[1]).diff(moment($scope.quote.dates[0]), 'days');
	    return days < 1 ? hours + ' hours' : days + ' days';
	  }
	  function goto_search(car_id) {
	    quote.car = car_id;
	    quote.update();
	    quote.goto_search();
	    // $('.search-form:first .btn_search').click();
	  }
	}
	angular.module('blc').filter('date_as_html', ['$sce','$filter', function($sce, $filter) {
	  return function(val) {
	    var day   = $filter('date')(val,'dd'),
	        month = $filter('date')(val,'MMM'),
	        week  = $filter('date')(val,'EEE');
	    return $sce.trustAsHtml('<b>'+day+'</b><b><i>'+month+'</i><u>'+week+'</u></b>');
	  }
	}]);


/***/ },
/* 30 */
/***/ function(module, exports) {

	angular.module('blc').controller('ContactController', ContactController);
	ContactController.$inject = ['$scope', '$element', '$http', 'quote', 'redcontrol'];
	function ContactController($scope, $element, $http, quote,redcontrol) {
	  $scope.contact_data = {} 
	  $scope.state = 'ready'
	  $scope.send_contact = function(evt) {
	    $scope.state = 'sending';
	    $http({
	      method: 'post',
	      url: '/contact',
	      data: this.contact_data
	    }).success( function(res) {
	      $scope.state = 'sent'
	      $scope.contact_data = {}
	      redcontrol.popup=null
	    })
	  }
	}


/***/ },
/* 31 */
/***/ function(module, exports) {

	angular.module('blc').directive('menuOnside', dir);
	function dir() {
	  return function($scope, $element) {
	    $element.append($('header .mainNav').clone()) 
	  }
	}


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var $ = jQuery = __webpack_require__(1)
	__webpack_require__(7);
	__webpack_require__(33);
	
	$(document).ready(function () {
	
	  var oldandroidmatch = navigator.userAgent.match(/Android.*4\.(\d)/);
	  if (oldandroidmatch && parseInt(oldandroidmatch[1])<4) {
	    $('body').addClass('oldandroid');
	  }
	
	  /*-------------------------------------mobile scripts--------------------------------------*/
	  if (isMobile()) {
	    $('body').addClass('mobile');
	
	    /*------------------------------ start sider ---------------------------------*/
	
	    if ($('.countries_wrap a').length > 2) $('.countries_wrap').mySlidePlugin(2, 10);
	    if ($('.carlist li').length > 1) $('.carlist').mySlidePlugin(1,0);
	    $('.innerservices').wrapInner('<div />').children().mySlidePlugin(1,1)
	
	    /*-----------------------------------------------------------------------------*/
	
	    $('.mobile_check_button').click(function () {
	      scroll_to_search_form();
	    })
	
	
	
	    /*------------------------------------------------------------------------------*/
	
	    $('.moblie_sticky button').click(function () {
	      ga('send','event', 'user action', 'click', 'mobile top sticky');
	      $('body').addClass('refine-search');
	      scroll_to_search_form();
	    })
	
	    $(window).on('scroll', function () {
	      if (window.pageYOffset > 50) {
	        $('body').addClass('mobile-sticky-visible');
	      } else {
	        $('body').removeClass('mobile-sticky-visible');
	      }
	    })
	
	  } else { /*not mobile*/
	    if ($('.countries_wrap a').length > 4) $('.countries_wrap').mySlidePlugin(3, 25);
	    if ($('.carlist li').length > 3) $('.carlist').mySlidePlugin(3, 77);
	    $('.innerservices').wrapInner('<div />').children().mySlidePlugin(1,1)
	
	    $(window).on('scroll', function () {
	      if ( window.scrollY > 400 ) {
	        $(".sticky").addClass("visible");
	      }
	      else {
	        $(".sticky").removeClass("visible");
	      }
	    })
	  }
	
	  /*---------------------------------------------click on submit gaq -----------------------------*/
	
	  $('body').on('click', '.gaq .button', function () {
	    $('.gaq').addClass('button_tuched');
	    $('.gaq.ng-valid').removeClass('button_tuched');
	  })
	
	  /*---------------------------------------------------------------------------------------------*/
	
	  /*    $('.columnWrapper .content .more').click(function(){
	        $('.columnWrapper .content').addClass('more');
	        })
	        $('.columnWrapper .content .less').click(function(){
	        $('.columnWrapper .content').removeClass('more');
	        })*/
	
	  /*---------------------------------------------------------------------------------------------*/
	
	  $('.wrapper.stage_two .search_button').click(function () {
	    $('.stage_two_main .right .wp').addClass('insearch');
	    setTimeout(function () {
	      $('.stage_two_main .right .wp').removeClass('insearch');
	      $('#search > nav > span').click(function () {
	        $('.stage_two_main .right .wp').addClass('insearch');
	        setTimeout(function () {
	          $('.stage_two_main .right .wp').removeClass('insearch');
	        }, 1500);
	      })
	    }, 2000);
	  })
	
	  /*----------------------------------------------------------------------------------------------*/
	  $('body').on('submit', '.send_email', function() {
	    var email = $(this).children('input').val();
	    $.post('/email', { email: email });
	    $('body').addClass('subscribed')
	    return false;
	  });
	
	  $('[role=availability]').click(function() {
	    $('.search_wrap .btn_search').trigger('click');
	  });
	  // --- show hide menu --- //
	  $('header .icon-menubutton').on('click', function() { $(this).toggleClass('active') });
	  $(document).click(function(event) { 
	    if (event.target.classList.contains('icon-menubutton')) return;
	    if ($(event.target).closest('.mainNav').length>0 || $(event.target).is('.mainNav')) return;
	    $('.icon-menubutton').removeClass('active');
	  })
	  // --- show hide menu --- //
	  $('.animNav,body>header').on('click', '.menuList .parent', function () {
	    var current_class = this.id;
	    $('.menulist_button,.menulist_block').addClass(current_class + ' active');
	    $('.menulist_button').click(function () {
	      $('.menulist_button,.menulist_block').removeClass('active');
	      setTimeout(function () {
	        $('.menulist_button,.menulist_block').removeClass(current_class)
	      }, 800);
	    })
	  })
	
	  $('body').append('<div id=static></div>');
	  $('body').on('click','[href="/about"],[href*="jobs"],[href="/faq"]', function (e) {
	    e.preventDefault();
	    $('#static').load(this.getAttribute('href') + ' div.static', function () {
	      $.magnificPopup.open({
	        mainClass: 'mfp-fade',
	        removalDelay: 400,
	        overflowY: 'scroll',
	        items: [
	      {
	        type: 'inline',
	        src: '#static'
	      }
	      ]
	      })
	      if($('body').hasClass('menu-active')){$('.icon').trigger('click');}
	    })
	  })
	
	  /*------------------------------- light box -------------------------------------------*/
	
	  $("header .icon").click(function (event) {
	    event.stopPropagation();
	    $('.wrapper').toggleClass("menu-active");
	
	  })
	  $('.lb').click(function (event) {
	    $('.wrapper').removeClass('menu-active');
	  })
	
	
	  /*--------------------------------------------------------------------------------------*/
	
	  $('.choose span').click(function () {
	    if ($(this).hasClass('choose_brand')) {
	      $('.result_block').removeClass('category').addClass('brand');
	    }
	    else if ($(this).hasClass('choose_category')) {
	      $('.result_block').removeClass('brand').addClass('category');
	    }
	  })
	
	  /*--------------------------------------car block slider--------------------------------*/
	
	  function create_image_slide() {
	    var imgArr = $('.car_block .img_wrap img');
	    $(imgArr[0]).addClass('active');
	    $('.car_block .slide').append(imgArr.clone());
	  }
	
	  if ($('body').hasClass('car_page')) {
	    create_image_slide();
	  }
	  $('.car_block .slide').on('click', 'img', function () {
	    switch_to_image_in_gallery(this);
	    clearInterval(gallery_interval);
	    $('.car_block .img_wrap iframe').remove();
	  });
	  $('.mobile .car_block').on('flick', '.img_wrap img', function (e) {
	    e.direction < 0 ? next_image_in_gallery() : prev_image_in_gallery();
	    clearInterval(gallery_interval)
	  });
	  function switch_to_image_in_gallery(elm) {
	    $('.car_block img').removeClass('active');
	    var ind = $('.car_block .slide img').index(elm);
	    $('.car_block .img_wrap img:eq(' + ind + ')').add(elm).addClass('active');
	        }
	
	        function prev_image_in_gallery() {
	          var next = $('.car_block .slide .active').prevAll('img')[0];
	          if (!next) next = $('.car_block .slide img:last')[0];
	          switch_to_image_in_gallery(next);
	        }
	
	        function next_image_in_gallery() {
	          var next = $('.car_block .slide .active').nextAll('img')[0];
	          if (!next) next = $('.car_block .slide img:first')[0];
	          switch_to_image_in_gallery(next);
	        }
	
	        var gallery_interval = setInterval(next_image_in_gallery, 5000);
	        if (isMobile()) { // move gallery in other block
	          $('.car_page .car_block').insertAfter('.car .right ul')
	        }
	
	        var video = $('.car_block .img_wrap img[data-video]:last').data('video');
	        if (video) {
	          $('.car_block .img_wrap').append($('<button>PLAY</button>').click(function (ev) {
	            $('.car_block .img_wrap').append('<iframe width="600" height="450" src="https://www.youtube.com/embed/' + video + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
	            clearInterval(gallery_interval);
	          }));
	        }
	
	        /*------------------------------------------------------------------------------------------*/
	
	        // image editorial
	        $('img[data-credentials],img[longdesc]').each(function () {
	          var cred = $(this).data('credentials') || $(this).attr('longdesc');
	          $(this).after($('<cite>' + cred + '</cite>'));
	        });
	        // image editorial
	
	
	
	        var car_page_map = function () {
	          var map;
	
	          function initialize() {
	            var mapOptions = {
	              zoom: 2,
	              center: new google.maps.LatLng(place.lat, place.lng)
	            };
	            var map_elm = document.getElementById('map');
	            if (!map_elm) return;
	            map = new google.maps.Map(map_elm, mapOptions);
	          }
	
	          google.maps.event.addDomListener(window, 'load', initialize);
	        };
	        // never run if (typeof(place) != 'undefined') car_page_map();
	})
	
	/*-------------------------------------------------------------------------*/
	
	
	
	
	


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jquery.finger - v0.1.4 - 2015-12-02
	* https://github.com/ngryman/jquery.finger
	* Copyright (c) 2015 Nicolas Gryman; Licensed MIT */
	!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("object"==typeof exports?require("jquery"):jQuery)}(function(a){function b(c){c.preventDefault(),a.event.remove(v,"click",b)}function c(a,b){return(q?b.originalEvent.touches[0]:b)["page"+a.toUpperCase()]}function d(c,d,e){var h=a.Event(d,x);a.event.trigger(h,{originalEvent:c},c.target),h.isDefaultPrevented()&&(~d.indexOf("tap")&&!q?a.event.add(v,"click",b):c.preventDefault()),e&&(a.event.remove(v,t+"."+u,f),a.event.remove(v,s+"."+u,g))}function e(e){var l=e.timeStamp||+new Date;j!=l&&(j=l,w.x=x.x=c("x",e),w.y=x.y=c("y",e),w.time=l,w.target=e.target,x.orientation=null,x.end=!1,h=!1,i=!1,k=setTimeout(function(){i=!0,d(e,"press")},y.pressDuration),a.event.add(v,t+"."+u,f),a.event.add(v,s+"."+u,g),y.preventDefault&&(e.preventDefault(),a.event.add(v,"click",b)))}function f(b){if(x.x=c("x",b),x.y=c("y",b),x.dx=x.x-w.x,x.dy=x.y-w.y,x.adx=Math.abs(x.dx),x.ady=Math.abs(x.dy),h=x.adx>y.motionThreshold||x.ady>y.motionThreshold){for(clearTimeout(k),x.orientation||(x.adx>x.ady?(x.orientation="horizontal",x.direction=x.dx>0?1:-1):(x.orientation="vertical",x.direction=x.dy>0?1:-1));b.target&&b.target!==w.target;)b.target=b.target.parentNode;return b.target!==w.target?(b.target=w.target,void g.call(this,a.Event(s+"."+u,b))):void d(b,"drag")}}function g(a){var b,c=a.timeStamp||+new Date,e=c-w.time;if(clearTimeout(k),h||i||a.target!==w.target)a.target=w.target,e<y.flickDuration&&d(a,"flick"),x.end=!0,b="drag";else{var f=l===a.target&&c-m<y.doubleTapInterval;b=f?"doubletap":"tap",l=f?null:w.target,m=c}d(a,b,!0)}var h,i,j,k,l,m,n=navigator.userAgent,o=/chrome/i.exec(n),p=/android/i.exec(n),q="ontouchstart"in window&&!(o&&!p),r=q?"touchstart":"mousedown",s=q?"touchend touchcancel":"mouseup mouseleave",t=q?"touchmove":"mousemove",u="finger",v=a("html")[0],w={},x={},y=a.Finger={pressDuration:300,doubleTapInterval:300,flickDuration:150,motionThreshold:5};return a.event.add(v,r+"."+u,e),a.each("tap doubletap press drag flick".split(" "),function(b,c){a.fn[c]=function(a){return a?this.on(c,a):this.trigger(c)}}),y});


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.js
 **/